import React from "react";

const index: React.FC = () => (
  <svg className="visually-hidden">
    <defs>
      <symbol id="iconGoogle" viewBox="0 0 19 18">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8203 7.43517L10.4783 7.43481C10.154 7.43481 9.89125 7.69757 9.89125 8.02178V10.3672C9.89125 10.6914 10.154 10.9542 10.4782 10.9542H14.6128C14.1601 12.1292 13.315 13.1131 12.2369 13.7384L13.9999 16.7902C16.828 15.1547 18.4999 12.2849 18.4999 9.07239C18.4999 8.61497 18.4662 8.28799 18.3988 7.91979C18.3475 7.64006 18.1047 7.43517 17.8203 7.43517Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8203 7.43517L10.4783 7.43481C10.154 7.43481 9.89125 7.69757 9.89125 8.02178V10.3672C9.89125 10.6914 10.154 10.9542 10.4782 10.9542H14.6128C14.1601 12.1292 13.315 13.1131 12.2369 13.7384L13.9999 16.7902C16.828 15.1547 18.4999 12.2849 18.4999 9.07239C18.4999 8.61497 18.4662 8.28799 18.3988 7.91979C18.3475 7.64006 18.1047 7.43517 17.8203 7.43517Z"
          fill="#167EE6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.50014 14.4783C7.47676 14.4783 5.71036 13.3727 4.76167 11.7368L1.7099 13.4958C3.26293 16.1875 6.17225 18 9.50014 18C11.1327 18 12.6731 17.5605 14.0001 16.7944V16.7902L12.2372 13.7383C11.4307 14.2061 10.4976 14.4783 9.50014 14.4783Z"
          fill="#12B347"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 16.7944V16.7903L12.237 13.7383C11.4306 14.206 10.4975 14.4783 9.5 14.4783V18C11.1326 18 12.6731 17.5605 14 16.7944Z"
          fill="#0F993E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.02174 9.00003C4.02174 8.00268 4.29392 7.0696 4.76154 6.26322L1.70976 4.50421C0.939523 5.82703 0.5 7.36329 0.5 9.00003C0.5 10.6368 0.939523 12.173 1.70976 13.4958L4.76154 11.7368C4.29392 10.9305 4.02174 9.99737 4.02174 9.00003Z"
          fill="#FFD500"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.50014 3.52174C10.8196 3.52174 12.0316 3.99059 12.9782 4.77046C13.2118 4.96283 13.5512 4.94895 13.7651 4.73502L15.427 3.07318C15.6697 2.83046 15.6524 2.43316 15.3931 2.20823C13.807 0.832254 11.7434 0 9.50014 0C6.17225 0 3.26293 1.81255 1.7099 4.50418L4.76167 6.26319C5.71036 4.62727 7.47675 3.52174 9.50014 3.52174Z"
          fill="#FF4B26"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9781 4.77046C13.2116 4.96283 13.5511 4.94895 13.765 4.73502L15.4268 3.07318C15.6695 2.83046 15.6522 2.43316 15.393 2.20823C13.8069 0.832219 11.7432 0 9.5 0V3.52174C10.8194 3.52174 12.0314 3.99059 12.9781 4.77046Z"
          fill="#D93F21"
        />
      </symbol>
      <symbol id="iconArrowRight" viewBox="0 0 10 9">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.0833435 4.5C0.0833435 4.08579 0.41913 3.75 0.833344 3.75H9.16668C9.58089 3.75 9.91668 4.08579 9.91668 4.5C9.91668 4.91421 9.58089 5.25 9.16668 5.25H0.833344C0.41913 5.25 0.0833435 4.91421 0.0833435 4.5Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.30301 0.636357C5.5959 0.343464 6.07078 0.343464 6.36367 0.636357L9.697 3.96969C9.83766 4.11034 9.91667 4.30111 9.91667 4.50002C9.91667 4.69893 9.83765 4.8897 9.697 5.03035L6.36367 8.36368C6.07078 8.65658 5.5959 8.65658 5.30301 8.36368C5.01012 8.07079 5.01012 7.59592 5.30301 7.30302L8.10601 4.50002L5.30301 1.69702C5.01012 1.40412 5.01012 0.92925 5.30301 0.636357Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconLocator" viewBox="0 0 16 20">
        <path
          id="Path_2190"
          data-name="Path 2190"
          d="M7,0A6.971,6.971,0,0,0,0,6.941a6.884,6.884,0,0,0,.268,1.9A5.116,5.116,0,0,0,.674,9.915C2.11,12.521,7,20,7,20s4.891-7.479,6.326-10.086a5.145,5.145,0,0,0,.407-1.074A6.934,6.934,0,0,0,7,0M7,9.376a2.462,2.462,0,0,1-1.923-.922,2.416,2.416,0,0,1-.534-1.513,2.457,2.457,0,0,1,4.913,0,2.415,2.415,0,0,1-.533,1.513A2.462,2.462,0,0,1,7,9.376"
          transform="translate(0 0)"
          fillRule="evenodd"
          clipRule="evenodd"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconArrowLeft" viewBox="0 0 14 15">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.52275 1.10225C7.74242 1.32192 7.74242 1.67808 7.52275 1.89775L2.358 7.0625H13.25C13.5607 7.0625 13.8125 7.31434 13.8125 7.625C13.8125 7.93566 13.5607 8.1875 13.25 8.1875H2.35799L7.52275 13.3523C7.74242 13.5719 7.74242 13.9281 7.52275 14.1477C7.30308 14.3674 6.94692 14.3674 6.72725 14.1477L0.602252 8.02275C0.382583 7.80308 0.382583 7.44692 0.602252 7.22725L6.72725 1.10225C6.94692 0.882583 7.30308 0.882583 7.52275 1.10225Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconChart" viewBox="0 0 15 15">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.141 8.12831C13.3818 8.12831 13.5784 8.32407 13.5626 8.56429C13.3383 11.9721 10.5031 14.6668 7.03846 14.6668C3.42737 14.6668 0.5 11.7394 0.5 8.12831C0.5 4.66372 3.19466 1.8285 6.60248 1.60415C6.8427 1.58833 7.03846 1.785 7.03846 2.02574V7.69241C7.03846 7.93315 7.23362 8.12831 7.47436 8.12831H13.141Z"
          className="icon-fill"
        />
        <path
          d="M14.6526 6.60248C14.6684 6.8427 14.4717 7.03846 14.231 7.03846H8.56431C8.32358 7.03846 8.12842 6.8433 8.12842 6.60256V0.935897C8.12842 0.695158 8.32418 0.498491 8.5644 0.514305C11.8281 0.729168 14.4377 3.33876 14.6526 6.60248Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconImport" viewBox="0 0 17 15">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.6665 2.4165C1.56193 2.4165 0.666504 3.31193 0.666504 4.4165V12.4998C0.666504 13.6044 1.56193 14.4998 2.6665 14.4998H14.9165C16.0211 14.4998 16.9165 13.6044 16.9165 12.4998V4.4165C16.9165 3.31193 16.0211 2.4165 14.9165 2.4165H2.6665ZM8.70817 5.33317C9.00733 5.33317 9.24984 5.57568 9.24984 5.87484V10.4005L10.8252 8.82515C11.0367 8.61362 11.3797 8.61362 11.5912 8.82515C11.8027 9.03669 11.8027 9.37965 11.5912 9.59119L9.09119 12.0912C8.9896 12.1928 8.85183 12.2498 8.70817 12.2498C8.56451 12.2498 8.42674 12.1928 8.32515 12.0912L5.82515 9.59119C5.61362 9.37965 5.61362 9.03669 5.82515 8.82515C6.03669 8.61362 6.37965 8.61362 6.59119 8.82515L8.1665 10.4005V5.87484C8.1665 5.57568 8.40902 5.33317 8.70817 5.33317Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.1665 1.58325C3.1665 0.892896 3.72615 0.333252 4.4165 0.333252H13.1665C13.8569 0.333252 14.4165 0.892896 14.4165 1.58325H3.1665Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconTransfers" viewBox="0 0 16 15">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.81,4.812,12.094.238a.544.544,0,0,0-.659-.192.7.7,0,0,0-.367.662V2.83h-4a.577.577,0,0,0-.53.614V6.878h-1.6v-1.9a.7.7,0,0,0-.368-.662.544.544,0,0,0-.659.192L.19,9.078a.909.909,0,0,0,0,1.111l3.716,4.574A.587.587,0,0,0,4.357,15a.5.5,0,0,0,.208-.046.7.7,0,0,0,.368-.663V12.17h4a.62.62,0,0,0,0-1.228H4.562a.751.751,0,0,0-.69.8v1.187L1.194,9.633l2.678-3.3v.969a.752.752,0,0,0,.69.8h.8a.47.47,0,0,0,.07.016h5.64v1.9a.7.7,0,0,0,.367.662.5.5,0,0,0,.209.046.587.587,0,0,0,.45-.237L15.81,5.922a.907.907,0,0,0,0-1.11"
          transform="translate(0 0)"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconUserManagement" viewBox="0 0 18 17">
        <path
          id="Path_2577"
          data-name="Path 2577"
          d="M7.3,8A3.368,3.368,0,0,1,4.721,6.825,4.046,4.046,0,0,1,3.649,4,4.046,4.046,0,0,1,4.721,1.175a3.414,3.414,0,0,1,5.155,0A4.046,4.046,0,0,1,10.948,4,4.046,4.046,0,0,1,9.876,6.825,3.368,3.368,0,0,1,7.3,8M.912,16a.842.842,0,0,1-.65-.288A1.015,1.015,0,0,1,0,15V13.2a3.24,3.24,0,0,1,.388-1.55,2.64,2.64,0,0,1,1.072-1.1,13.557,13.557,0,0,1,2.623-1.1A10.882,10.882,0,0,1,7.3,9h.319a.8.8,0,0,1,.274.05,7.506,7.506,0,0,0-.308.938A8.546,8.546,0,0,0,7.39,11a7.813,7.813,0,0,0-.068,1.512A9.871,9.871,0,0,0,7.572,14a6.7,6.7,0,0,0,.365,1.038,8.6,8.6,0,0,0,.5.962Zm12.772-2a1.687,1.687,0,0,0,1.289-.587,2.132,2.132,0,0,0,0-2.826,1.708,1.708,0,0,0-2.577,0,2.129,2.129,0,0,0,0,2.826A1.684,1.684,0,0,0,13.685,14M12.5,15.5c-.182-.083-.354-.171-.514-.262a3.989,3.989,0,0,1-.49-.338l-.981.325a.4.4,0,0,1-.3-.013A.518.518,0,0,1,9.99,15l-.547-1a.44.44,0,0,1-.057-.325.535.535,0,0,1,.171-.3l.753-.725a4.654,4.654,0,0,1,0-1.3l-.753-.725a.535.535,0,0,1-.171-.3A.44.44,0,0,1,9.442,10L9.99,9a.527.527,0,0,1,.228-.213.407.407,0,0,1,.3-.012L11.5,9.1a3.989,3.989,0,0,1,.49-.338c.16-.091.331-.179.514-.262L12.7,7.4a.607.607,0,0,1,.16-.287A.375.375,0,0,1,13.137,7h1.095a.375.375,0,0,1,.274.113.607.607,0,0,1,.16.287l.205,1.1a4.4,4.4,0,0,1,.514.275,3.6,3.6,0,0,1,.49.375l.958-.375a.336.336,0,0,1,.308,0A.59.59,0,0,1,17.379,9l.547,1.05a.492.492,0,0,1-.091.625l-.775.725a4.3,4.3,0,0,1,0,1.25l.753.725a.535.535,0,0,1,.171.3.44.44,0,0,1-.057.325l-.547,1a.518.518,0,0,1-.228.212.4.4,0,0,1-.3.013l-.981-.325a3.989,3.989,0,0,1-.49.338c-.16.091-.331.179-.514.262l-.205,1.1a.607.607,0,0,1-.16.287.375.375,0,0,1-.274.113H13.137a.375.375,0,0,1-.274-.113.607.607,0,0,1-.16-.287Z"
          fillRule="evenodd"
          clipRule="evenodd"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconRoleManagement" viewBox="0 0 18 18">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666504 4.6665C0.666504 2.45737 2.45737 0.666504 4.6665 0.666504H13.3332C15.5423 0.666504 17.3332 2.45737 17.3332 4.6665V13.3332C17.3332 15.5423 15.5423 17.3332 13.3332 17.3332H4.6665C2.45737 17.3332 0.666504 15.5423 0.666504 13.3332V4.6665ZM8.76653 8.53317C10.2415 8.53317 11.4499 7.33317 11.4499 5.84983C11.4499 4.3665 10.2499 3.1665 8.76653 3.1665C7.2832 3.1665 6.0832 4.3665 6.0832 5.84983C6.0832 7.33317 7.29153 8.53317 8.76653 8.53317ZM7.09154 9.3415H10.7832C12.4915 9.3415 13.8749 10.7248 13.8832 12.4332V12.7748C13.8832 13.5748 13.2249 14.2332 12.4249 14.2332H5.4582C4.6582 14.2332 3.99986 13.5748 3.99986 12.7748V12.4332C3.99986 10.7332 5.3832 9.3415 7.09154 9.3415Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconNotifications" viewBox="0 0 16 18">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.70001 16.0083H10.3083C9.85001 16.8083 8.9917 17.3333 8.00836 17.3333C7.00836 17.3333 6.15835 16.8083 5.70001 16.0083Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7667 13.325C15.7667 13.7416 15.6334 14.125 15.425 14.4416C15.0667 14.9666 14.475 15.3166 13.7917 15.3166H2.21669C2.00836 15.3166 1.80836 15.2833 1.62503 15.225C1.18336 15.0916 0.816681 14.8166 0.566681 14.4416C0.358348 14.125 0.225037 13.7416 0.225037 13.325C0.225037 12.4333 0.816689 11.6833 1.61669 11.425C1.74169 11.3916 1.86668 11.3666 2.00002 11.35V7.54163C2.00002 4.45829 4.35002 1.92496 7.34168 1.59163V1.31662C7.34168 0.958292 7.63335 0.666626 7.99168 0.666626C8.35002 0.666626 8.64168 0.958292 8.64168 1.31662V1.59163C9.99168 1.74163 11.25 2.33329 12.225 3.31662C13.3584 4.43329 13.9834 5.94163 13.9834 7.54163V11.35C14.9834 11.4583 15.7667 12.3 15.7667 13.325Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconChevronLeft" viewBox="0 0 5 10">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.23436 0.808011C3.53763 0.454205 4.07029 0.413231 4.42409 0.716494C4.7779 1.01976 4.81887 1.55242 4.51561 1.90622L3.23436 0.808011ZM0.928558 4.79462L0.287936 5.34372C0.0170994 5.02775 0.0170995 4.56149 0.287936 4.24551L0.928558 4.79462ZM4.51561 7.68301C4.81887 8.03682 4.7779 8.56948 4.42409 8.87274C4.07029 9.176 3.53763 9.13503 3.23436 8.78122L4.51561 7.68301ZM4.51561 1.90622L1.56918 5.34372L0.287936 4.24551L3.23436 0.808011L4.51561 1.90622ZM1.56918 4.24551L4.51561 7.68301L3.23436 8.78122L0.287936 5.34372L1.56918 4.24551Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconChevronRight" viewBox="0 0 5 8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.71203 4.24559C4.98287 4.56156 4.98287 5.02782 4.71203 5.3438L1.7656 8.7813C1.46234 9.13511 0.929683 9.17608 0.575877 8.87282C0.222071 8.56955 0.181097 8.0369 0.484359 7.68309L2.96013 4.79469L0.484359 1.9063C0.181097 1.55249 0.222071 1.01983 0.575877 0.71657C0.929683 0.413308 1.46234 0.454281 1.7656 0.808088L4.71203 4.24559Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconChevronDown" viewBox="0 0 10 6">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.13636 1.13634C1.42925 0.843443 1.90412 0.843443 2.19702 1.13634L5.00002 3.93934L7.80302 1.13634C8.09592 0.843443 8.57079 0.843443 8.86368 1.13634C9.15658 1.42923 9.15658 1.9041 8.86368 2.197L5.53035 5.53033C5.3897 5.67098 5.19893 5.75 5.00002 5.75C4.80111 5.75 4.61034 5.67098 4.46969 5.53033L1.13636 2.197C0.843464 1.9041 0.843464 1.42923 1.13636 1.13634Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconDownload" viewBox="0 0 18 18">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconEdit" viewBox="0 0 18 18">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.25 15C8.25 14.5858 8.58579 14.25 9 14.25H15C15.4142 14.25 15.75 14.5858 15.75 15C15.75 15.4142 15.4142 15.75 15 15.75H9C8.58579 15.75 8.25 15.4142 8.25 15Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2883 3.75C13.162 3.75 13.0369 3.77488 12.9202 3.82321C12.8036 3.87154 12.6975 3.94238 12.6082 4.03169L4.57897 12.0609L4.06893 13.9311L5.93908 13.421L13.9683 5.39179C14.0576 5.30249 14.1285 5.19647 14.1768 5.07978C14.2251 4.9631 14.25 4.83804 14.25 4.71174C14.25 4.58544 14.2251 4.46038 14.1768 4.3437C14.1285 4.22702 14.0576 4.12099 13.9683 4.03169C13.879 3.94238 13.773 3.87154 13.6563 3.82321C13.5396 3.77488 13.4146 3.75 13.2883 3.75ZM12.3462 2.43739C12.6449 2.31367 12.965 2.25 13.2883 2.25C13.6116 2.25 13.9317 2.31367 14.2303 2.43739C14.529 2.5611 14.8004 2.74243 15.029 2.97103C15.2576 3.19962 15.4389 3.471 15.5626 3.76967C15.6863 4.06835 15.75 4.38846 15.75 4.71174C15.75 5.03502 15.6863 5.35513 15.5626 5.65381C15.4389 5.95248 15.2576 6.22386 15.029 6.45245L6.8589 14.6225C6.76661 14.7148 6.65183 14.7814 6.52591 14.8158L3.19736 15.7236C2.9377 15.7944 2.66 15.7206 2.46969 15.5303C2.27937 15.34 2.20563 15.0623 2.27644 14.8027L3.18423 11.4741C3.21857 11.3482 3.28518 11.2334 3.37747 11.1411L11.5476 2.97103C11.7762 2.74243 12.0475 2.5611 12.3462 2.43739Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconMoveRight" viewBox="0 0 18 18">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.46967 11.5303C0.176777 11.2374 0.176777 10.7626 0.46967 10.4697L4.93934 6L0.469671 1.53033C0.176778 1.23744 0.176778 0.762562 0.469671 0.46967C0.762564 0.176776 1.23744 0.176776 1.53033 0.46967L6.53033 5.46967C6.82322 5.76256 6.82322 6.23744 6.53033 6.53033L1.53033 11.5303C1.23744 11.8232 0.762563 11.8232 0.46967 11.5303Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconFilter" viewBox="0 0 15 15">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.446374 1.01395C0.570068 0.751055 0.83447 0.583252 1.12501 0.583252H13.875C14.1655 0.583252 14.4299 0.751055 14.5536 1.01395C14.6773 1.27684 14.6381 1.58752 14.4529 1.81137L9.66667 7.59581V13.3749C9.66667 13.6349 9.53209 13.8763 9.31097 14.0129C9.08986 14.1496 8.81376 14.162 8.58127 14.0457L5.74793 12.6291C5.49384 12.502 5.33334 12.2423 5.33334 11.9583V7.59581L0.547167 1.81137C0.36195 1.58752 0.32268 1.27684 0.446374 1.01395ZM2.71903 2.08325L6.66118 6.84763C6.77246 6.98212 6.83334 7.1512 6.83334 7.32575V11.4947L8.16668 12.1614V7.32575C8.16668 7.1512 8.22756 6.98212 8.33883 6.84763L12.281 2.08325H2.71903Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconEnter" viewBox="0 0 12 12">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.0151 1.0151C1.40893 0.621274 1.94307 0.400024 2.50002 0.400024C3.05698 0.400024 3.59112 0.621274 3.98495 1.0151C4.37878 1.40893 4.60002 1.94307 4.60002 2.50002V3.40002H6.40002V2.50002C6.40002 1.94307 6.62127 1.40893 7.0151 1.0151C7.40893 0.621274 7.94307 0.400024 8.50002 0.400024C9.05698 0.400024 9.59112 0.621274 9.98495 1.0151C10.3788 1.40893 10.6 1.94307 10.6 2.50002C10.6 3.05698 10.3788 3.59112 9.98495 3.98495C9.59112 4.37878 9.05698 4.60002 8.50002 4.60002H7.60002V6.40002H8.50002C9.05698 6.40002 9.59112 6.62127 9.98495 7.0151C10.3788 7.40893 10.6 7.94307 10.6 8.50002C10.6 9.05698 10.3788 9.59112 9.98495 9.98495C9.59112 10.3788 9.05698 10.6 8.50002 10.6C7.94307 10.6 7.40893 10.3788 7.0151 9.98495C6.62127 9.59112 6.40002 9.05698 6.40002 8.50002V7.60002H4.60002V8.50002C4.60002 9.05698 4.37878 9.59112 3.98495 9.98495C3.59112 10.3788 3.05698 10.6 2.50002 10.6C1.94307 10.6 1.40893 10.3788 1.0151 9.98495C0.621274 9.59112 0.400024 9.05698 0.400024 8.50002C0.400024 7.94307 0.621274 7.40893 1.0151 7.0151C1.40893 6.62127 1.94307 6.40002 2.50002 6.40002H3.40002V4.60002H2.50002C1.94307 4.60002 1.40893 4.37878 1.0151 3.98495C0.621274 3.59112 0.400024 3.05698 0.400024 2.50002C0.400024 1.94307 0.621274 1.40893 1.0151 1.0151ZM3.40002 3.40002V2.50002C3.40002 2.26133 3.3052 2.03241 3.13642 1.86363C2.96764 1.69485 2.73872 1.60002 2.50002 1.60002C2.26133 1.60002 2.03241 1.69485 1.86363 1.86363C1.69485 2.03241 1.60002 2.26133 1.60002 2.50002C1.60002 2.73872 1.69485 2.96764 1.86363 3.13642C2.03241 3.3052 2.26133 3.40002 2.50002 3.40002H3.40002ZM4.60002 4.60002V6.40002H6.40002V4.60002H4.60002ZM3.40002 7.60002H2.50002C2.26133 7.60002 2.03241 7.69485 1.86363 7.86363C1.69485 8.03241 1.60002 8.26133 1.60002 8.50002C1.60002 8.73872 1.69485 8.96764 1.86363 9.13642C2.03241 9.3052 2.26133 9.40002 2.50002 9.40002C2.73872 9.40002 2.96764 9.3052 3.13642 9.13642C3.3052 8.96764 3.40002 8.73872 3.40002 8.50002V7.60002ZM7.60002 7.60002V8.50002C7.60002 8.73872 7.69485 8.96764 7.86363 9.13642C8.03241 9.3052 8.26133 9.40002 8.50002 9.40002C8.73872 9.40002 8.96764 9.3052 9.13642 9.13642C9.3052 8.96764 9.40002 8.73872 9.40002 8.50002C9.40002 8.26133 9.3052 8.03241 9.13642 7.86363C8.96764 7.69485 8.73872 7.60002 8.50002 7.60002H7.60002ZM7.60002 3.40002H8.50002C8.73872 3.40002 8.96764 3.3052 9.13642 3.13642C9.3052 2.96764 9.40002 2.73872 9.40002 2.50002C9.40002 2.26133 9.3052 2.03241 9.13642 1.86363C8.96764 1.69485 8.73872 1.60002 8.50002 1.60002C8.26133 1.60002 8.03241 1.69485 7.86363 1.86363C7.69485 2.03241 7.60002 2.26133 7.60002 2.50002V3.40002Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconChevronUp" viewBox="0 0 10 6">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.1363 4.86366C1.42919 5.15656 1.90406 5.15656 2.19696 4.86366L4.99996 2.06066L7.80296 4.86366C8.09586 5.15656 8.57073 5.15656 8.86362 4.86366C9.15652 4.57077 9.15652 4.0959 8.86362 3.803L5.53029 0.46967C5.38964 0.329018 5.19887 0.25 4.99996 0.25C4.80105 0.25 4.61028 0.329018 4.46963 0.46967L1.1363 3.803C0.843403 4.0959 0.843403 4.57077 1.1363 4.86366Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconSearch" viewBox="0 0 17 17">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.66667 1.75C4.39898 1.75 1.75 4.39898 1.75 7.66667C1.75 10.9344 4.39898 13.5833 7.66667 13.5833C9.30072 13.5833 10.7789 12.9219 11.8504 11.8504C12.9219 10.7789 13.5833 9.30072 13.5833 7.66667C13.5833 4.39898 10.9344 1.75 7.66667 1.75ZM0.25 7.66667C0.25 3.57055 3.57055 0.25 7.66667 0.25C11.7628 0.25 15.0833 3.57055 15.0833 7.66667C15.0833 9.4443 14.4572 11.0768 13.4146 12.354L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L12.354 13.4146C11.0768 14.4572 9.4443 15.0833 7.66667 15.0833C3.57055 15.0833 0.25 11.7628 0.25 7.66667Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconSort" viewBox="0 0 8 12">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.46967 0.21967C3.76256 -0.0732233 4.23744 -0.0732233 4.53033 0.21967L7.53033 3.21967C7.82322 3.51256 7.82322 3.98744 7.53033 4.28033C7.23744 4.57322 6.76256 4.57322 6.46967 4.28033L4 1.81066L1.53033 4.28033C1.23744 4.57322 0.762563 4.57322 0.46967 4.28033C0.176777 3.98744 0.176777 3.51256 0.46967 3.21967L3.46967 0.21967ZM0.46967 7.71967C0.762563 7.42678 1.23744 7.42678 1.53033 7.71967L4 10.1893L6.46967 7.71967C6.76256 7.42678 7.23744 7.42678 7.53033 7.71967C7.82322 8.01256 7.82322 8.48744 7.53033 8.78033L4.53033 11.7803C4.38968 11.921 4.19891 12 4 12C3.80109 12 3.61032 11.921 3.46967 11.7803L0.46967 8.78033C0.176777 8.48744 0.176777 8.01256 0.46967 7.71967Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconPreference" viewBox="0 0 15 15">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3659 8.235L12.9834 8.0175C12.7134 7.86 12.6834 7.605 12.6834 7.5C12.6834 7.395 12.7134 7.14 12.9834 6.9825L13.3659 6.765C13.7634 6.5325 14.0484 6.165 14.1609 5.7225C14.2809 5.28 14.2209 4.815 13.9959 4.4175L13.2234 3.0825C12.7509 2.265 11.6934 1.98 10.8759 2.4525L10.4934 2.67C10.2234 2.8275 9.98337 2.7225 9.90087 2.67C9.81087 2.625 9.60087 2.4675 9.60087 2.16V1.7175C9.60087 0.772501 8.82836 0 7.88336 0H6.33837C5.39337 0 4.62086 0.772501 4.62086 1.7175V2.16C4.62086 2.4675 4.41087 2.625 4.32837 2.67C4.23837 2.7225 3.99836 2.8275 3.72836 2.67L3.34587 2.4525C2.52837 1.98 1.47835 2.265 1.00585 3.0825L0.233355 4.4175C-0.246645 5.235 0.0383755 6.2925 0.863376 6.765L1.23838 6.9825C1.50838 7.14 1.53837 7.395 1.53837 7.5C1.53837 7.605 1.50838 7.86 1.23838 8.0175L0.863376 8.235C0.0383755 8.7075 -0.246645 9.765 0.233355 10.5825L1.00585 11.9175C1.23085 12.315 1.59837 12.6 2.04837 12.72C2.49087 12.84 2.94837 12.7725 3.34587 12.5475L3.72836 12.33C3.99836 12.1725 4.23837 12.2775 4.32837 12.33C4.41087 12.375 4.62086 12.5325 4.62086 12.84V13.2825C4.62086 14.2275 5.39337 15 6.33837 15H7.88336C8.82836 15 9.60087 14.2275 9.60087 13.2825V12.84C9.60087 12.5325 9.81087 12.375 9.90087 12.33C9.98337 12.2775 10.2234 12.1725 10.4934 12.33L10.8759 12.5475C11.2734 12.7725 11.7309 12.84 12.1809 12.72C12.6234 12.6 12.9909 12.315 13.2234 11.9175L13.9959 10.5825C14.2209 10.185 14.2809 9.72 14.1609 9.2775C14.0484 8.835 13.7634 8.4675 13.3659 8.235ZM4.62086 7.5C4.62086 6.1275 5.73837 5.01 7.11087 5.01C8.48337 5.01 9.60087 6.1275 9.60087 7.5C9.60087 8.8725 8.48337 9.99 7.11087 9.99C5.73837 9.99 4.62086 8.8725 4.62086 7.5Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconMapLocator" viewBox="0 0 32 32">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.5476 29.4963C8.71375 27.7304 7.01448 25.83 5.46398 23.8108C1.9645 19.2525 0.128686 15.1641 0.00770314 11.6594C-0.0470292 10.1816 0.190327 8.70744 0.706169 7.32147C1.22201 5.9355 2.00621 4.66492 3.01384 3.58249C4.02148 2.50005 5.23277 1.62704 6.57832 1.01345C7.92387 0.399858 9.37725 0.0577433 10.8552 0.00669974C12.3332 -0.0443439 13.8067 0.196681 15.1914 0.715981C16.5761 1.23528 17.8447 2.02266 18.9246 3.033C20.0045 4.04334 20.8745 5.25679 21.4847 6.60387C22.095 7.95094 22.4334 9.40517 22.4808 10.8833C22.6018 14.3882 21.052 18.5933 17.8755 23.3822C16.468 25.5035 14.9038 27.5165 13.1961 29.4046C13.0284 29.5847 12.8267 29.73 12.6027 29.832C12.3787 29.934 12.1367 29.9907 11.8907 29.9988C11.8688 29.9996 11.847 30 11.8252 30C11.3508 30.0005 10.894 29.8204 10.5476 29.4963V29.4963ZM10.921 1.90749C9.69127 1.94994 8.482 2.23419 7.36218 2.74399C6.24235 3.25379 5.2339 3.97917 4.39441 4.8787C3.55492 5.77824 2.90082 6.83431 2.46947 7.98663C2.03811 9.13895 1.83795 10.365 1.88041 11.5946C2.13912 19.0857 11.8263 28.1264 11.8263 28.1264C11.8263 28.1264 20.8668 18.4391 20.6081 10.9481C20.5244 8.52161 19.5019 6.22235 17.7563 4.53484C16.0106 2.84733 13.678 1.90337 11.2501 1.90187C11.141 1.90187 11.0308 1.90362 10.921 1.90749ZM5.62255 11.1519C5.62255 10.0401 5.95226 8.95318 6.56997 8.02871C7.18769 7.10423 8.06567 6.3837 9.09289 5.95821C10.1201 5.53272 11.2504 5.42139 12.3409 5.63831C13.4314 5.85522 14.4331 6.39063 15.2193 7.17683C16.0055 7.96303 16.5409 8.96471 16.7578 10.0552C16.9747 11.1457 16.8634 12.276 16.4379 13.3032C16.0124 14.3305 15.2919 15.2084 14.3674 15.8262C13.4429 16.4439 12.3561 16.7736 11.2442 16.7736C9.75377 16.7719 8.32487 16.179 7.27098 15.1251C6.21708 14.0712 5.62426 12.6424 5.62255 11.1519V11.1519ZM7.61355 11.1519C7.61355 12.5555 8.65684 14.7826 11.2442 14.7826C13.8316 14.7826 14.8748 12.6586 14.8748 11.1519C14.8748 9.64521 13.8316 7.52128 11.2442 7.52128C8.65684 7.52128 7.61355 9.74874 7.61355 11.1519Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconPersonalDetails" viewBox="0 0 12 14">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.70025 6.28333C7.43358 6.28333 8.84192 4.875 8.84192 3.14166C8.84192 1.40833 7.43358 0 5.70025 0C3.96692 0 2.55859 1.40833 2.55859 3.14166C2.55859 4.875 3.96692 6.28333 5.70025 6.28333Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8 11.1917V12.625C11.8 12.9667 11.525 13.25 11.175 13.25H0.625C0.283333 13.25 0 12.9667 0 12.625V11.1917C0 9.18338 1.63333 7.55005 3.64166 7.55005H8.15833C8.56666 7.55005 8.95834 7.61671 9.325 7.75005C9.325 7.75005 9.325 7.74171 9.33333 7.75005C10.7667 8.23338 11.8 9.59172 11.8 11.1917Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.8 11.1917V12.625C11.8 12.9667 11.525 13.25 11.175 13.25H0.625C0.283333 13.25 0 12.9667 0 12.625V11.1917C0 9.18338 1.63333 7.55005 3.64166 7.55005H8.15833C8.56666 7.55005 8.95834 7.61671 9.325 7.75005C9.325 7.75005 9.325 7.74171 9.33333 7.75005C10.7667 8.23338 11.8 9.59172 11.8 11.1917Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconSignout" viewBox="0 0 13 12">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.09192 0.0365696C0.710985 0.127994 0.317351 0.413697 0.154819 0.715398C-0.0153328 1.0331 -0.00263491 0.649114 0.00244423 5.9106L0.010063 10.6853L0.0837106 10.8452C0.233545 11.1698 0.462107 11.3984 0.787172 11.5538C1.11986 11.7115 0.921769 11.7024 4.34511 11.7024H7.43577L7.6364 11.6452C8.13924 11.5012 8.53541 11.1081 8.64461 10.6395C8.67509 10.507 8.6827 10.2007 8.6827 8.8979V7.31625L7.20467 7.3094C5.90695 7.30026 5.70633 7.29568 5.57173 7.2614C5.01048 7.11741 4.56606 6.72657 4.40098 6.2283C4.3375 6.04088 4.3375 5.66147 4.40098 5.47405C4.56606 4.97807 5.01556 4.58266 5.57173 4.44095C5.70379 4.40667 5.90949 4.40209 7.20467 4.39295L8.6827 4.3861V2.80445C8.6827 1.50165 8.67509 1.19538 8.64461 1.06281C8.53541 0.59426 8.13924 0.201134 7.6364 0.0571404L7.43577 0L4.33242 0.00228596C1.70904 0.00228596 1.20874 0.00914221 1.09192 0.0365696Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0363 3.4627C9.95508 3.49927 9.88143 3.55641 9.83572 3.61583L9.76207 3.70954L9.74684 5.34833L7.77359 5.3529L5.80034 5.35976L5.68606 5.4169C5.62511 5.4489 5.53876 5.51975 5.49559 5.57232C5.42702 5.66375 5.4194 5.68889 5.4194 5.85117C5.4194 6.01344 5.42702 6.03859 5.49559 6.13001C5.53876 6.18258 5.62511 6.25343 5.68606 6.28543L5.80034 6.34257L7.77359 6.34943L9.74684 6.354L9.76207 7.99279L9.83572 8.0865C9.9754 8.26706 10.2776 8.34706 10.5062 8.26249C10.623 8.21906 12.8781 6.20086 12.9518 6.07516C12.9848 6.01802 13 5.94488 13 5.85117C13 5.75746 12.9848 5.68432 12.9518 5.62718C12.8781 5.50147 10.623 3.48327 10.5062 3.43984C10.364 3.38727 10.1862 3.39641 10.0363 3.4627Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconImageUpload" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.95146 0.550049C1.01177 0.550049 0.25 1.31182 0.25 2.25151V13.0573C0.25 13.997 1.01177 14.7588 1.95146 14.7588H5.08984V17.5801C5.08984 18.7742 6.05784 19.7422 7.25192 19.7422H17.1365C18.3306 19.7422 19.2986 18.7742 19.2986 17.5801V7.69553C19.2986 6.50145 18.3306 5.53345 17.1365 5.53345H14.4587V2.25151C14.4587 1.31182 13.697 0.550049 12.7573 0.550049H1.95146ZM12.9587 5.53345V2.25151C12.9587 2.14024 12.8685 2.05005 12.7573 2.05005H1.95146C1.84019 2.05005 1.75 2.14024 1.75 2.25151V13.0573C1.75 13.1686 1.8402 13.2588 1.95146 13.2588H5.08984V7.69553C5.08984 6.50145 6.05784 5.53345 7.25192 5.53345H12.9587ZM6.58984 7.69553C6.58984 7.32987 6.88627 7.03345 7.25192 7.03345H17.1365C17.5021 7.03345 17.7986 7.32987 17.7986 7.69553V13.5144L15.8198 11.6947C15.5568 11.4528 15.1524 11.4528 14.8894 11.6947L7.76973 18.2422H7.25192C6.88627 18.2422 6.58984 17.9458 6.58984 17.5801V7.69553ZM11.8259 10.7541C11.8259 11.7253 11.0356 12.5126 10.0608 12.5126C9.08592 12.5126 8.29565 11.7253 8.29565 10.7541C8.29565 9.78291 9.08592 8.99561 10.0608 8.99561C11.0356 8.99561 11.8259 9.78291 11.8259 10.7541Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconLock" viewBox="0 0 12 15">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.185 6.59253H1.48146C0.663273 6.59253 0 7.2558 0 8.07399V13.2591C0 14.0773 0.663273 14.7406 1.48146 14.7406H10.185C11.0032 14.7406 11.6665 14.0773 11.6665 13.2591V8.07399C11.6665 7.2558 11.0032 6.59253 10.185 6.59253Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.83347 1.79993C5.1616 1.79993 4.51725 2.06683 4.04216 2.54192C3.56707 3.017 3.30017 3.66136 3.30017 4.33323V6.99986C3.30017 7.44168 2.94201 7.79985 2.50018 7.79985C2.05836 7.79985 1.7002 7.44168 1.7002 6.99986V4.33323C1.7002 3.23702 2.13566 2.1857 2.9108 1.41056C3.68594 0.63542 4.73726 0.199951 5.83347 0.199951C6.92969 0.199951 7.981 0.63542 8.75614 1.41056C9.53128 2.1857 9.96675 3.23702 9.96675 4.33323V6.99986C9.96675 7.44168 9.60858 7.79985 9.16676 7.79985C8.72494 7.79985 8.36677 7.44168 8.36677 6.99986V4.33323C8.36677 3.66136 8.09987 3.017 7.62478 2.54192C7.1497 2.06683 6.50534 1.79993 5.83347 1.79993Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconInfo" viewBox="0 0 18 18">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.3337 9.00008C17.3337 13.6025 13.6027 17.3334 9.00033 17.3334C4.39795 17.3334 0.666992 13.6025 0.666992 9.00008C0.666992 4.39771 4.39795 0.666748 9.00033 0.666748C13.6027 0.666748 17.3337 4.39771 17.3337 9.00008ZM9.83366 5.66675C9.83366 5.20651 9.46056 4.83342 9.00033 4.83342C8.54009 4.83342 8.16699 5.20651 8.16699 5.66675V9.00008C8.16699 9.46032 8.54009 9.83342 9.00033 9.83342C9.46056 9.83342 9.83366 9.46032 9.83366 9.00008V5.66675ZM9.00033 11.5001C8.54009 11.5001 8.16699 11.8732 8.16699 12.3334C8.16699 12.7937 8.54009 13.1667 9.00033 13.1667H9.00866C9.4689 13.1667 9.84199 12.7937 9.84199 12.3334C9.84199 11.8732 9.4689 11.5001 9.00866 11.5001H9.00033Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconPersonnel" viewBox="0 0 16 20">
        <path
          id="Path_2086"
          data-name="Path 2086"
          d="M15.562,14.664A2.978,2.978,0,0,0,14.4,13.52,14.389,14.389,0,0,0,11.25,12.3,13.056,13.056,0,0,0,8.5,11.92v7.453H15a.941.941,0,0,0,.712-.3A1.044,1.044,0,0,0,16,18.32V16.309a3.2,3.2,0,0,0-.438-1.645m-1.979.5H9.694V13.935h3.889Z"
          transform="translate(0 0.627)"
          fillRule="evenodd"
          clipRule="evenodd"
          className="icon-fill"
        />
        <path
          id="Path_2087"
          data-name="Path 2087"
          d="M4.75,12.3A14.389,14.389,0,0,0,1.6,13.52,2.978,2.978,0,0,0,.438,14.664,3.2,3.2,0,0,0,0,16.309V18.32a1.044,1.044,0,0,0,.288.749.941.941,0,0,0,.712.3H7.5V11.92a13.056,13.056,0,0,0-2.75.376m1.745,2.866H2.606V13.935H6.495Z"
          transform="translate(0 0.627)"
          fillRule="evenodd"
          clipRule="evenodd"
          className="icon-fill"
        />
        <path
          id="Path_2088"
          data-name="Path 2088"
          d="M12.065,5.263H3.135s-1.288-.452-.7-1.541A10.029,10.029,0,0,1,8.545.024a9.2,9.2,0,0,1,2.736.185s2.031.965,1.83,2.794-1.046,2.26-1.046,2.26"
          transform="translate(0 0)"
          fillRule="evenodd"
          clipRule="evenodd"
          className="icon-fill"
        />
        <path
          id="Path_2089"
          data-name="Path 2089"
          d="M4.114,6A4.4,4.4,0,0,0,3.9,7.345a4.165,4.165,0,0,0,1.175,2.974,3.845,3.845,0,0,0,5.65,0A4.165,4.165,0,0,0,11.9,7.345,4.4,4.4,0,0,0,11.678,6Z"
          transform="translate(0 0.316)"
          fillRule="evenodd"
          clipRule="evenodd"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconImportNew" viewBox="0 0 16 16">
        <path
          id="Path_2573"
          data-name="Path 2573"
          d="M5.382,3.442C5.893,1.661,6.758.34,7.6.051a1.547,1.547,0,0,1,.792,0c.853.287,1.716,1.608,2.231,3.4.113.4.32,1.254.32,1.337,0,.01-1.322.017-2.939.017s-2.939-.007-2.939-.017c0-.083.2-.937.32-1.337M4.268.9A7.553,7.553,0,0,1,5.32.445c.291-.106.385-.13.385-.1,0,.007-.084.137-.185.29A11.137,11.137,0,0,0,4.085,4.47L4.021,4.8H2.336c-.925,0-1.68-.014-1.68-.026a2.86,2.86,0,0,1,.16-.344A8.1,8.1,0,0,1,4.263.9M10.309.338a2.761,2.761,0,0,0,.183.3,11.1,11.1,0,0,1,1.436,3.832l.064.327h1.68c.959,0,1.68-.014,1.68-.03A8.362,8.362,0,0,0,14.7,3.592a6.867,6.867,0,0,0-1-1.224A7.824,7.824,0,0,0,11.572.82,4.821,4.821,0,0,0,10.31.34M.008,8A6.148,6.148,0,0,1,.193,6.153l.069-.291H3.869l-.021.191a21.586,21.586,0,0,0,0,3.885l.021.192H.261L.193,9.838A6.132,6.132,0,0,1,.008,8M4.884,6.053a21.885,21.885,0,0,0,0,3.885l.023.192H7.4a4.629,4.629,0,0,1,3.8-2.985c-.014-.4-.04-.77-.075-1.089L11.1,5.865H4.912Zm10.98,3.574a4.625,4.625,0,0,0-3.63-2.492c-.012-.4-.036-.732-.074-1.083l-.021-.191h3.607l.07.291a9.609,9.609,0,0,1,.048,3.475M7.146,11.2a4.942,4.942,0,0,0-.03.533,4.612,4.612,0,0,0,1.96,3.776,2.151,2.151,0,0,1-.3.24,1.225,1.225,0,0,1-.853.247.98.98,0,0,1-.525-.144,5.532,5.532,0,0,1-2.026-3.3c-.114-.4-.319-1.254-.319-1.338,0-.007.881-.014,2.08-.016m-6.489.016a5.358,5.358,0,0,0,.426.851,8.086,8.086,0,0,0,3.146,3.015,6.381,6.381,0,0,0,1.452.581,1.264,1.264,0,0,0-.17-.293,11.171,11.171,0,0,1-1.436-3.841L4,11.206H2.336c-.925,0-1.68.006-1.68.016"
          transform="translate(0 0)"
          fillRule="evenodd"
          clipRule="evenodd"
          className="icon-fill"
        />
        <path
          id="Path_2574"
          data-name="Path 2574"
          d="M14.58,14.69l1.331-1.311a.683.683,0,0,1,.481-.2.654.654,0,0,1,.5.2.718.718,0,0,1,0,.979L14.37,16.875a.677.677,0,0,1-.981,0l-2.522-2.518a.638.638,0,0,1-.2-.49.7.7,0,0,1,.218-.49.736.736,0,0,1,.49-.2.644.644,0,0,1,.49.2l1.313,1.311V11.123a.7.7,0,1,1,1.4,0Z"
          transform="translate(-2.135 -2.099)"
          fillRule="evenodd"
          clipRule="evenodd"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconUnit" viewBox="0 0 16 20">
        <path
          id="Path_2168"
          data-name="Path 2168"
          d="M.672.043a1.318,1.318,0,0,0-.625.61c-.062.218-.062,18.47,0,18.689a1.266,1.266,0,0,0,.646.615,1.537,1.537,0,0,0,.828-.032,1.163,1.163,0,0,0,.537-.52c.09-.179.09.088.1-4.392l.008-4.508.1-.028a1.667,1.667,0,0,0,.326-.179,5.42,5.42,0,0,1,1.887-.734A7.634,7.634,0,0,1,6.221,9.55a5.525,5.525,0,0,1,1.271.385,5.2,5.2,0,0,1,1.275.852,5.547,5.547,0,0,0,2.791,1.328,8.129,8.129,0,0,0,2.083,0,6.086,6.086,0,0,0,2-.742c.391-.251.359.138.359-4.469,0-4.538.021-4.237-.3-4.437-.242-.15-.476-.134-.93.069a4.948,4.948,0,0,1-2.4.463,4.293,4.293,0,0,1-1.617-.305A5.5,5.5,0,0,1,9.041,1.585,5.528,5.528,0,0,0,6.5.4,8.542,8.542,0,0,0,4.316.4a6.036,6.036,0,0,0-1.871.682,2.624,2.624,0,0,1-.249.143A1.119,1.119,0,0,1,2.154.982a1.057,1.057,0,0,0-.63-.911A1.635,1.635,0,0,0,.675.042"
          transform="translate(0 0)"
          fillRule="evenodd"
          clipRule="evenodd"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconArmoury" viewBox="0 0 16 20">
        <rect
          id="Rectangle_1797"
          data-name="Rectangle 1797"
          width="4"
          height="3"
          transform="translate(6 9.793)"
          className="icon-fill"
          fillRule="evenodd"
          clipRule="evenodd"
        />
        <rect
          id="Rectangle_1798"
          data-name="Rectangle 1798"
          width="4"
          height="3"
          transform="translate(6 14.793)"
          className="icon-fill"
          fillRule="evenodd"
          clipRule="evenodd"
        />

        <path
          id="Path_2201"
          data-name="Path 2201"
          d="M15.2,5.047,8.8.247a1.417,1.417,0,0,0-1.6,0L.8,5.047a2.261,2.261,0,0,0-.8,1.6V16.793a1,1,0,0,0,1,1H3a1,1,0,0,0,1-1v-4H3.969V7.813H4.9c.036,0,.066-.02.1-.02h6c.036,0,.067.017.1.02h.929v4.98H12v4a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V6.647a2.261,2.261,0,0,0-.8-1.6"
          transform="translate(0 0)"
          className="icon-fill"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </symbol>
      <symbol id="iconWeapons" viewBox="0 0 18 14">
        <path
          id="Path_2169"
          data-name="Path 2169"
          d="M17.04,2.337l.029-.209A1.175,1.175,0,0,0,15.9.735H3.6V0H2.7V.735h0A1.386,1.386,0,0,0,1.342,2.142v1.1a2.784,2.784,0,0,0,.616,1.89c.339.266.363,1.06.053,1.764L.128,11.174a1.63,1.63,0,0,0,.605,1.992l.9.553c1.81,1.02,2.489-1.041,2.629-1.306l.844-1.706A2.609,2.609,0,0,1,6.9,9.53H8.543a1.31,1.31,0,0,0,1.071-.636l1.741-3.072,3.894,0a1.664,1.664,0,0,0,1.512-1.45l.016-.116H18V2.337ZM8.677,8.454H6.531l1.4-2.581h2.146Z"
          transform="translate(0 0)"
          className="icon-fill"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </symbol>
      <symbol id="iconAmmunition" viewBox="0 0 16 16">
        <path
          className="icon-fill"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.252,4.824C6.3.6,4.163,0,3.276,0S.255.6.3,4.824Z"
          transform="translate(0 0)"
        />
        <path
          className="icon-fill"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.549,6.739H0c0,.05,0,.09,0,.147v7.785l.936.8v.8H0v.8H6.554v-.8H5.617v-.8l.937-.8V6.886c0-.057,0-.1-.005-.147"
          transform="translate(0 -1.064)"
        />
        <path
          className="icon-fill"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7,4.824C15.744.6,13.609,0,12.722,0S9.7.6,9.748,4.824Z"
          transform="translate(0 0)"
        />
        <path
          className="icon-fill"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.995,6.739H9.45c0,.05,0,.09,0,.147v7.785l.936.8v.8H9.446v.8H16v-.8h-.937v-.8l.937-.8V6.886c0-.057,0-.1-.005-.147"
          transform="translate(0 -1.064)"
        />
      </symbol>
      <symbol id="iconSpotCheck" viewBox="0 0 16 18">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.95,9.6,5.575,8.329a1.063,1.063,0,0,0-1.424,0,.887.887,0,0,0-.313.647.806.806,0,0,0,.287.649L6.25,11.56a1.034,1.034,0,0,0,1.4,0L11.9,7.691a.852.852,0,0,0,0-1.3,1.067,1.067,0,0,0-1.425,0ZM8,18H7.75a.538.538,0,0,1-.226-.046,10.175,10.175,0,0,1-5.4-3.7A9.789,9.789,0,0,1,0,8.147v-4.3A1.6,1.6,0,0,1,.363,2.822a2.046,2.046,0,0,1,.937-.66L7.3.113a2.224,2.224,0,0,1,1.4,0l6,2.049a2.049,2.049,0,0,1,.938.66A1.6,1.6,0,0,1,16,3.845v4.3a9.789,9.789,0,0,1-2.126,6.11,10.175,10.175,0,0,1-5.4,3.7A1.618,1.618,0,0,1,8,18"
          transform="translate(0 0)"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconExport" viewBox="0 0 15 14">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.19582 1.02912C7.05422 1.09377 4.99646 3.30822 4.90909 3.49249C4.82473 3.67029 4.82172 3.97094 4.90607 4.14228C5.07178 4.49142 5.4755 4.62073 5.80992 4.43646C5.86717 4.40413 6.12024 4.15844 6.36729 3.89012L6.81922 3.40197L6.84935 9.46342L6.93371 9.61536C7.05422 9.83842 7.24101 9.94834 7.4971 9.94834C7.71101 9.94511 7.82249 9.89985 7.96108 9.75114C8.15691 9.53778 8.14486 9.77054 8.1539 6.42785L8.15992 3.39227L8.66608 3.92568C9.15717 4.44616 9.17525 4.46232 9.34397 4.50435C9.6573 4.5787 9.9405 4.43969 10.0821 4.14551C10.1695 3.96124 10.1725 3.67676 10.0911 3.50542C10.0158 3.35025 7.87069 1.05498 7.75922 1.01295C7.63569 0.961227 7.31935 0.970926 7.19582 1.02912Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.793619 5.85563C0.727337 5.88795 0.636952 5.95584 0.59176 6.00757C0.41099 6.2177 0.417016 6.09485 0.417016 8.99142C0.417016 10.7694 0.429067 11.6973 0.450157 11.8136C0.468234 11.9074 0.540542 12.1175 0.612849 12.2791C0.823747 12.7447 1.16721 13.0809 1.64625 13.2878L1.84811 13.3751H13.1462L13.3481 13.2878C13.9506 13.0292 14.3754 12.5119 14.5321 11.8557C14.6014 11.5647 14.6014 6.39873 14.5291 6.22093C14.3363 5.71985 13.6704 5.6455 13.3842 6.09162L13.2968 6.22416L13.2818 8.87827C13.2667 11.7975 13.2788 11.6132 13.0799 11.8136C12.8841 12.0141 13.2818 12.0011 7.49113 12.0011C2.40247 12.0011 2.20362 11.9979 2.08612 11.9397C1.95054 11.8718 1.85413 11.7781 1.77881 11.6294C1.73362 11.5421 1.72759 11.2738 1.71253 8.87827L1.69747 6.22416L1.61009 6.09162C1.44138 5.82653 1.06779 5.71985 0.793619 5.85563Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconAssign" viewBox="0 0 15 14">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.25 1.19995C0.25 0.785738 0.585786 0.449951 1 0.449951H12.7735C13.1877 0.449951 13.5235 0.785738 13.5235 1.19995C13.5235 1.61416 13.1877 1.94995 12.7735 1.94995H1C0.585786 1.94995 0.25 1.61416 0.25 1.19995ZM14.4513 4.84472C14.7821 5.09397 14.8483 5.56421 14.599 5.89504L9.21157 13.0459C8.93466 13.4135 8.40214 13.4645 8.0605 13.1561C8.0605 13.1561 8.0605 13.1561 8.06049 13.1561L5.2204 10.5929C4.9129 10.3153 4.88861 9.84108 5.16613 9.53359C5.44366 9.22609 5.91791 9.2018 6.2254 9.47932L8.48449 11.5182L13.401 4.99244C13.6502 4.66161 14.1205 4.59547 14.4513 4.84472ZM0.25 6.56081C0.25 6.1466 0.585786 5.81081 1 5.81081H8.82651C9.24072 5.81081 9.57651 6.1466 9.57651 6.56081C9.57651 6.97502 9.24072 7.31081 8.82651 7.31081H1C0.585786 7.31081 0.25 6.97502 0.25 6.56081ZM0.25 11.9586C0.25 11.5444 0.585786 11.2086 1 11.2086H3.46265C3.87686 11.2086 4.21265 11.5444 4.21265 11.9586C4.21265 12.3728 3.87686 12.7086 3.46265 12.7086H1C0.585786 12.7086 0.25 12.3728 0.25 11.9586Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconPlus" viewBox="0 0 12 12">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.99967 0.583252C6.41389 0.583252 6.74967 0.919038 6.74967 1.33325V5.24992H10.6663C11.0806 5.24992 11.4163 5.58571 11.4163 5.99992C11.4163 6.41413 11.0806 6.74992 10.6663 6.74992H6.74967V10.6666C6.74967 11.0808 6.41389 11.4166 5.99967 11.4166C5.58546 11.4166 5.24967 11.0808 5.24967 10.6666V6.74992H1.33301C0.918794 6.74992 0.583008 6.41413 0.583008 5.99992C0.583008 5.58571 0.918794 5.24992 1.33301 5.24992H5.24967V1.33325C5.24967 0.919038 5.58546 0.583252 5.99967 0.583252Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconCheck" viewBox="0 0 13 10">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.364 0.96967C12.6569 1.26256 12.6569 1.73744 12.364 2.03033L5.03066 9.36366C4.89 9.50431 4.69924 9.58333 4.50033 9.58333C4.30141 9.58333 4.11065 9.50431 3.97 9.36366L0.636662 6.03033C0.343769 5.73744 0.343769 5.26256 0.636662 4.96967C0.929555 4.67678 1.40443 4.67678 1.69732 4.96967L4.50033 7.77267L11.3033 0.96967C11.5962 0.676777 12.0711 0.676777 12.364 0.96967Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconClose" viewBox="0 0 10 10">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.46967 0.46967C0.762563 0.176777 1.23744 0.176777 1.53033 0.46967L5 3.93934L8.46967 0.46967C8.76256 0.176777 9.23744 0.176777 9.53033 0.46967C9.82322 0.762563 9.82322 1.23744 9.53033 1.53033L6.06066 5L9.53033 8.46967C9.82322 8.76256 9.82322 9.23744 9.53033 9.53033C9.23744 9.82322 8.76256 9.82322 8.46967 9.53033L5 6.06066L1.53033 9.53033C1.23744 9.82322 0.762563 9.82322 0.46967 9.53033C0.176777 9.23744 0.176777 8.76256 0.46967 8.46967L3.93934 5L0.46967 1.53033C0.176777 1.23744 0.176777 0.762563 0.46967 0.46967Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconDatepicker" viewBox="0 0 18 19">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.66667 0.416667C6.08088 0.416667 6.41667 0.752453 6.41667 1.16667V2.08333H11.5833V1.16667C11.5833 0.752453 11.9191 0.416667 12.3333 0.416667C12.7475 0.416667 13.0833 0.752453 13.0833 1.16667V2.08333H14.8333C16.168 2.08333 17.25 3.16531 17.25 4.5V16.1667C17.25 17.5014 16.168 18.5833 14.8333 18.5833H3.16667C1.83198 18.5833 0.75 17.5014 0.75 16.1667V4.5C0.75 3.16531 1.83198 2.08333 3.16667 2.08333H4.91667V1.16667C4.91667 0.752453 5.25245 0.416667 5.66667 0.416667ZM4.91667 3.58333H3.16667C2.66041 3.58333 2.25 3.99374 2.25 4.5V7.08333H15.75V4.5C15.75 3.99374 15.3396 3.58333 14.8333 3.58333H13.0833V4.5C13.0833 4.91421 12.7475 5.25 12.3333 5.25C11.9191 5.25 11.5833 4.91421 11.5833 4.5V3.58333H6.41667V4.5C6.41667 4.91421 6.08088 5.25 5.66667 5.25C5.25245 5.25 4.91667 4.91421 4.91667 4.5V3.58333ZM15.75 8.58333H2.25V16.1667C2.25 16.6729 2.66041 17.0833 3.16667 17.0833H14.8333C15.3396 17.0833 15.75 16.6729 15.75 16.1667V8.58333Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconInfoOutline" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.99967 2.08325C4.73199 2.08325 2.08301 4.73223 2.08301 7.99992C2.08301 11.2676 4.73199 13.9166 7.99967 13.9166C11.2674 13.9166 13.9163 11.2676 13.9163 7.99992C13.9163 4.73223 11.2674 2.08325 7.99967 2.08325ZM0.583008 7.99992C0.583008 3.90381 3.90356 0.583252 7.99967 0.583252C12.0958 0.583252 15.4163 3.90381 15.4163 7.99992C15.4163 12.096 12.0958 15.4166 7.99967 15.4166C3.90356 15.4166 0.583008 12.096 0.583008 7.99992ZM7.24967 5.33325C7.24967 4.91904 7.58546 4.58325 7.99967 4.58325H8.00634C8.42056 4.58325 8.75634 4.91904 8.75634 5.33325C8.75634 5.74747 8.42056 6.08325 8.00634 6.08325H7.99967C7.58546 6.08325 7.24967 5.74747 7.24967 5.33325ZM7.99967 7.24992C8.41389 7.24992 8.74967 7.5857 8.74967 7.99992V10.6666C8.74967 11.0808 8.41389 11.4166 7.99967 11.4166C7.58546 11.4166 7.24967 11.0808 7.24967 10.6666V7.99992C7.24967 7.5857 7.58546 7.24992 7.99967 7.24992Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconDelete" viewBox="0 0 12 12">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.85747 1.75C5.76541 1.75 5.66926 1.78806 5.59245 1.86871C5.51445 1.95061 5.46461 2.06917 5.46461 2.2V2.91667H8.53604V2.2C8.53604 2.06917 8.4862 1.95061 8.4082 1.86871C8.33139 1.78806 8.23524 1.75 8.14318 1.75H5.85747ZM10.036 2.91667V2.2C10.036 1.69432 9.84507 1.20242 9.49441 0.83423C9.14257 0.464797 8.65733 0.25 8.14318 0.25H5.85747C5.34332 0.25 4.85808 0.464797 4.50624 0.83423C4.15559 1.20242 3.96461 1.69431 3.96461 2.2V2.91667H1.66699C1.25278 2.91667 0.916992 3.25245 0.916992 3.66667C0.916992 4.07271 1.23967 4.4034 1.64259 4.41628L2.25062 11.8342C2.25904 12.3278 2.44922 12.8059 2.79196 13.1658C3.1438 13.5352 3.62903 13.75 4.14318 13.75H9.85747C10.3716 13.75 10.8569 13.5352 11.2087 13.1658C11.5514 12.8059 11.7416 12.3278 11.75 11.8342L12.3581 4.41628C12.761 4.4034 13.0837 4.07271 13.0837 3.66667C13.0837 3.25245 12.7479 2.91667 12.3337 2.91667H10.036ZM9.28664 4.41667C9.28644 4.41667 9.28624 4.41667 9.28604 4.41667C9.28584 4.41667 9.28564 4.41667 9.28543 4.41667L4.71522 4.41667C4.71501 4.41667 4.71481 4.41667 4.71461 4.41667C4.71441 4.41667 4.71421 4.41667 4.71401 4.41667H3.14765L3.74782 11.7387C3.74949 11.7591 3.75033 11.7796 3.75033 11.8C3.75033 11.9308 3.80017 12.0494 3.87816 12.1313C3.95498 12.2119 4.05113 12.25 4.14318 12.25H9.85747C9.94953 12.25 10.0457 12.2119 10.1225 12.1313C10.2005 12.0494 10.2503 11.9308 10.2503 11.8C10.2503 11.7796 10.2512 11.7591 10.2528 11.7387L10.853 4.41667H9.28664ZM5.66699 5.58333C6.08121 5.58333 6.41699 5.91912 6.41699 6.33333V9.66667C6.41699 10.0809 6.08121 10.4167 5.66699 10.4167C5.25278 10.4167 4.91699 10.0809 4.91699 9.66667V6.33333C4.91699 5.91912 5.25278 5.58333 5.66699 5.58333ZM8.33366 5.58333C8.74787 5.58333 9.08366 5.91912 9.08366 6.33333V9.66667C9.08366 10.0809 8.74787 10.4167 8.33366 10.4167C7.91944 10.4167 7.58366 10.0809 7.58366 9.66667V6.33333C7.58366 5.91912 7.91944 5.58333 8.33366 5.58333Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconRefresh" viewBox="0 0 18 16">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6403 2.31631C9.67991 2.03852 8.6648 2.00854 7.68969 2.22917C6.71458 2.4498 5.81126 2.91385 5.064 3.57802C4.31674 4.24219 3.74991 5.08483 3.4164 6.02732C3.27822 6.4178 2.84965 6.62234 2.45916 6.48416C2.06868 6.34598 1.86414 5.91741 2.00232 5.52692C2.42037 4.34557 3.13086 3.28936 4.0675 2.45686C5.00415 1.62436 6.13642 1.0427 7.35867 0.766151C8.58091 0.489603 9.85329 0.527181 11.0571 0.87538C12.257 1.22246 13.3498 1.8669 14.2342 2.74885L16.4002 4.78415V2.07243C16.4002 1.65821 16.736 1.32243 17.1502 1.32243C17.5644 1.32243 17.9002 1.65821 17.9002 2.07243V6.51805C17.9002 6.93226 17.5644 7.26805 17.1502 7.26805H12.7046C12.2904 7.26805 11.9546 6.93226 11.9546 6.51805C11.9546 6.10383 12.2904 5.76805 12.7046 5.76805H15.2568L13.1987 3.83414C13.193 3.82877 13.1873 3.82331 13.1818 3.81777C12.475 3.11066 11.6007 2.59411 10.6403 2.31631ZM0.0996094 9.48179C0.0996094 9.06758 0.435396 8.73179 0.849609 8.73179H5.29523C5.70944 8.73179 6.04523 9.06758 6.04523 9.48179C6.04523 9.89601 5.70944 10.2318 5.29523 10.2318H2.74302L4.80114 12.1657C4.80685 12.1711 4.81248 12.1765 4.81802 12.1821C5.52478 12.8892 6.39914 13.4058 7.35953 13.6835C8.31992 13.9613 9.33503 13.9913 10.3101 13.7707C11.2852 13.5501 12.1886 13.086 12.9358 12.4218C13.6831 11.7577 14.2499 10.915 14.5834 9.97254C14.7216 9.58206 15.1502 9.37752 15.5407 9.5157C15.9311 9.65388 16.1357 10.0825 15.9975 10.4729C15.5795 11.6543 14.869 12.7105 13.9323 13.543C12.9957 14.3755 11.8634 14.9572 10.6412 15.2337C9.41892 15.5103 8.14653 15.4727 6.94274 15.1245C5.74281 14.7774 4.65002 14.133 3.76564 13.251L1.59961 11.2157V13.9274C1.59961 14.3416 1.26382 14.6774 0.849609 14.6774C0.435396 14.6774 0.0996094 14.3416 0.0996094 13.9274V9.48179Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconMap" viewBox="0 0 18 17">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.90062 1.0307C6.11835 0.906288 6.38385 0.898919 6.60814 1.01106L11.7037 3.55883L16.1279 1.0307C16.36 0.898059 16.6452 0.899011 16.8764 1.0332C17.1077 1.16739 17.25 1.41453 17.25 1.68189V12.591C17.25 12.8601 17.1058 13.1086 16.8721 13.2422L12.0994 15.9694C11.8817 16.0938 11.6162 16.1012 11.3919 15.9891L6.29633 13.4413L1.8721 15.9694C1.63998 16.1021 1.35479 16.1011 1.12355 15.9669C0.892319 15.8327 0.75 15.5856 0.75 15.3182V4.40916C0.75 4.14001 0.894215 3.89151 1.1279 3.75798L5.90062 1.0307ZM7.02273 12.1274L10.9773 14.1047V4.87268L7.02273 2.89541V12.1274ZM5.52273 2.97427V12.1557L2.25 14.0259V4.8444L5.52273 2.97427ZM12.4773 4.8444V14.0259L15.75 12.1557V2.97427L12.4773 4.8444Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconLocationInfo" viewBox="0 0 17 17">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00019 16C8.87019 16 9.71019 15.86 10.4942 15.604C10.107 15.1005 9.78013 14.5535 9.52019 13.974C9.02419 14.675 8.48619 15 8.00019 15C7.34319 15 6.59319 14.41 5.97819 13.092C5.74411 12.5794 5.55733 12.0466 5.42019 11.5H9.00419C9.01619 11.158 9.06319 10.823 9.14119 10.5H5.20619C5.06723 9.67396 4.99832 8.83765 5.00019 8C5.00019 7.117 5.07319 6.275 5.20619 5.5H10.7942C10.9142 6.204 10.9862 6.963 10.9982 7.758C11.3002 7.552 11.6292 7.383 11.9842 7.258C11.9584 6.66914 11.8993 6.0822 11.8072 5.5H14.5402C14.7502 6.049 14.8932 6.631 14.9592 7.236C15.3332 7.363 15.6802 7.538 15.9962 7.753C15.9477 6.18201 15.4374 4.66012 14.5292 3.37734C13.621 2.09455 12.3551 1.10772 10.8894 0.540034C9.4238 -0.0276471 7.82341 -0.151021 6.28808 0.185316C4.75275 0.521654 3.3505 1.3028 2.25642 2.43123C1.16234 3.55965 0.424891 4.98536 0.136154 6.53036C-0.152584 8.07535 0.0201804 9.67116 0.632877 11.1186C1.24557 12.566 2.27105 13.8008 3.58129 14.669C4.89152 15.5371 6.42845 16 8.00019 16ZM8.00019 1C8.65719 1 9.40719 1.59 10.0222 2.908C10.2392 3.374 10.4282 3.91 10.5812 4.5H5.41919C5.57219 3.91 5.76119 3.374 5.97919 2.908C6.59219 1.59 7.34219 1 8.00019 1ZM5.07219 2.485C4.7769 3.13182 4.54806 3.80695 4.38919 4.5H1.93619C2.78043 3.04087 4.12142 1.93415 5.71419 1.382C5.47319 1.712 5.25819 2.086 5.07219 2.485ZM4.19219 5.5C4.06277 6.32702 3.99857 7.16292 4.00019 8C4.00019 8.87 4.06719 9.712 4.19319 10.5H1.46019C1.15522 9.70182 0.999301 8.85446 1.00019 8C1.00019 7.12 1.16319 6.276 1.46019 5.5H4.19219ZM4.38919 11.5C4.56519 12.243 4.79619 12.922 5.07219 13.515C5.25819 13.914 5.47319 14.288 5.71419 14.618C4.12142 14.0659 2.78043 12.9591 1.93619 11.5H4.38919ZM10.2862 1.382C11.879 1.93407 13.22 3.04081 14.0642 4.5H11.6102C11.4513 3.80695 11.2225 3.13182 10.9272 2.485C10.7491 2.09756 10.5341 1.72819 10.2852 1.382H10.2862ZM17.0002 11.682C17.0002 9.649 15.5352 8.001 13.5012 8.001C11.4682 8.001 10.0002 9.649 10.0002 11.682C10.0002 13.206 10.9822 15.212 13.2562 16.918C13.4012 17.028 13.6012 17.028 13.7462 16.918C16.0222 15.212 17.0002 13.206 17.0002 11.682ZM15.0002 11.5C15.0002 11.8978 14.8422 12.2794 14.5608 12.5607C14.2795 12.842 13.898 13 13.5002 13C13.1024 13 12.7208 12.842 12.4395 12.5607C12.1582 12.2794 12.0002 11.8978 12.0002 11.5C12.0002 11.1022 12.1582 10.7206 12.4395 10.4393C12.7208 10.158 13.1024 10 13.5002 10C13.898 10 14.2795 10.158 14.5608 10.4393C14.8422 10.7206 15.0002 11.1022 15.0002 11.5Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconExpand" viewBox="0 0 12 12">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.5 2.25C7.08579 2.25 6.75 1.91421 6.75 1.5C6.75 1.08579 7.08579 0.75 7.5 0.75H10.5C10.9142 0.75 11.25 1.08579 11.25 1.5V4.5C11.25 4.91421 10.9142 5.25 10.5 5.25C10.0858 5.25 9.75 4.91421 9.75 4.5V3.31066L3.31066 9.75H4.5C4.91421 9.75 5.25 10.0858 5.25 10.5C5.25 10.9142 4.91421 11.25 4.5 11.25H1.5C1.08579 11.25 0.75 10.9142 0.75 10.5V7.5C0.75 7.08579 1.08579 6.75 1.5 6.75C1.91421 6.75 2.25 7.08579 2.25 7.5V8.68934L8.68934 2.25H7.5Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconAssigned" viewBox="0 0 15 8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4784 0.46967C10.7713 0.762563 10.7713 1.23744 10.4784 1.53033L6.88359 5.12513L7.82798 6.08641L13.4447 0.46967C13.7376 0.176777 14.2125 0.176777 14.5054 0.46967C14.7983 0.762563 14.7983 1.23744 14.5054 1.53033L8.35358 7.68213C8.21212 7.8236 8.01999 7.90268 7.81993 7.90179C7.61987 7.9009 7.42845 7.82012 7.28824 7.6774L5.82289 6.18584L4.3266 7.68213C4.18595 7.82278 3.99518 7.9018 3.79627 7.9018C3.59736 7.9018 3.40659 7.82278 3.26594 7.68213L0.46967 4.88586C0.176777 4.59296 0.176777 4.11809 0.46967 3.8252C0.762563 3.5323 1.23744 3.5323 1.53033 3.8252L3.79627 6.09114L9.41774 0.46967C9.71063 0.176777 10.1855 0.176777 10.4784 0.46967Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconViewImage" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75 1.8125C2.23223 1.8125 1.8125 2.23223 1.8125 2.75V13.25C1.8125 13.7678 2.23223 14.1875 2.75 14.1875H13.25C13.7678 14.1875 14.1875 13.7678 14.1875 13.25V2.75C14.1875 2.23223 13.7678 1.8125 13.25 1.8125H2.75ZM0.6875 2.75C0.6875 1.61091 1.61091 0.6875 2.75 0.6875H13.25C14.3891 0.6875 15.3125 1.61091 15.3125 2.75V13.25C15.3125 14.3891 14.3891 15.3125 13.25 15.3125H2.75C1.61091 15.3125 0.6875 14.3891 0.6875 13.25V2.75Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.375 4.8125C5.06434 4.8125 4.8125 5.06434 4.8125 5.375C4.8125 5.68566 5.06434 5.9375 5.375 5.9375C5.68566 5.9375 5.9375 5.68566 5.9375 5.375C5.9375 5.06434 5.68566 4.8125 5.375 4.8125ZM3.6875 5.375C3.6875 4.44302 4.44302 3.6875 5.375 3.6875C6.30698 3.6875 7.0625 4.44302 7.0625 5.375C7.0625 6.30698 6.30698 7.0625 5.375 7.0625C4.44302 7.0625 3.6875 6.30698 3.6875 5.375Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.54159 7.16291C10.347 6.35746 11.6529 6.35745 12.4584 7.16291L15.1477 9.85225C15.3674 10.0719 15.3674 10.4281 15.1477 10.6477C14.9281 10.8674 14.5719 10.8674 14.3523 10.6477L11.6629 7.95841C11.2968 7.59229 10.7032 7.59229 10.3371 7.95841L3.14775 15.1477C2.92808 15.3674 2.57192 15.3674 2.35225 15.1477C2.13258 14.9281 2.13258 14.5719 2.35225 14.3523L9.54159 7.16291Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconHamburger" viewBox="0 0 20 16">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 1.70933C0.5 1.25501 0.868296 0.886719 1.32261 0.886719H18.5975C19.0518 0.886719 19.4201 1.25501 19.4201 1.70933C19.4201 2.16365 19.0518 2.53194 18.5975 2.53194H1.32261C0.868296 2.53194 0.5 2.16365 0.5 1.70933Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 8.2902C0.5 7.83589 0.868296 7.46759 1.32261 7.46759H18.5975C19.0518 7.46759 19.4201 7.83589 19.4201 8.2902C19.4201 8.74452 19.0518 9.11282 18.5975 9.11282H1.32261C0.868296 9.11282 0.5 8.74452 0.5 8.2902Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 14.8711C0.5 14.4168 0.868296 14.0485 1.32261 14.0485H18.5975C19.0518 14.0485 19.4201 14.4168 19.4201 14.8711C19.4201 15.3254 19.0518 15.6937 18.5975 15.6937H1.32261C0.868296 15.6937 0.5 15.3254 0.5 14.8711Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconCopy" viewBox="0 0 14 14">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.83015 0.830154C5.20162 0.458688 5.70544 0.25 6.23077 0.25H11.7692C12.2946 0.25 12.7984 0.458688 13.1698 0.830154C13.5413 1.20162 13.75 1.70544 13.75 2.23077V7.76923C13.75 8.29456 13.5413 8.79838 13.1698 9.16985C12.7984 9.54131 12.2946 9.75 11.7692 9.75H11.1538C10.7396 9.75 10.4038 9.41421 10.4038 9C10.4038 8.58579 10.7396 8.25 11.1538 8.25H11.7692C11.8967 8.25 12.019 8.19935 12.1092 8.10919C12.1993 8.01902 12.25 7.89674 12.25 7.76923V2.23077C12.25 2.10326 12.1993 1.98098 12.1092 1.89081C12.019 1.80065 11.8967 1.75 11.7692 1.75H6.23077C6.10326 1.75 5.98098 1.80065 5.89081 1.89081C5.80065 1.98098 5.75 2.10326 5.75 2.23077V2.84615C5.75 3.26037 5.41421 3.59615 5 3.59615C4.58579 3.59615 4.25 3.26037 4.25 2.84615V2.23077C4.25 1.70544 4.45869 1.20162 4.83015 0.830154ZM0.25 6.33333C0.25 5.18274 1.18274 4.25 2.33333 4.25H7.66667C8.81726 4.25 9.75 5.18274 9.75 6.33333V11.6667C9.75 12.8173 8.81726 13.75 7.66667 13.75H2.33333C1.18274 13.75 0.25 12.8173 0.25 11.6667V6.33333ZM2.33333 5.75C2.01117 5.75 1.75 6.01117 1.75 6.33333V11.6667C1.75 11.9888 2.01117 12.25 2.33333 12.25H7.66667C7.98883 12.25 8.25 11.9888 8.25 11.6667V6.33333C8.25 6.01117 7.98883 5.75 7.66667 5.75H2.33333Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconMinus" viewBox="0 0 14 2">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.0371094 1C0.0371094 0.585786 0.372896 0.25 0.787109 0.25H12.4538C12.868 0.25 13.2038 0.585786 13.2038 1C13.2038 1.41421 12.868 1.75 12.4538 1.75H0.787109C0.372896 1.75 0.0371094 1.41421 0.0371094 1Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconActivityLog" viewBox="0 0 14 14">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.36741 0.0504719C3.32398 0.0768473 3.26427 0.121686 3.23713 0.150698C3.21271 0.179711 3.04443 0.56743 2.86531 1.01054C2.57762 1.72795 2.53962 1.83872 2.53962 1.97851C2.53962 2.06555 2.55862 2.1816 2.58305 2.23699C2.62918 2.34777 2.76217 2.49283 2.86531 2.54558C2.9983 2.61152 4.59144 3.08628 4.68372 3.08628C4.81399 3.08364 4.99041 3.00188 5.05554 2.9122C5.18582 2.73285 5.19125 2.49547 5.0664 2.32403C4.98498 2.21589 4.95241 2.20007 4.49374 2.055L4.1002 1.93368L4.29018 1.84664C5.14782 1.46419 5.97018 1.30067 6.90924 1.32704C8.05457 1.35869 9.02891 1.65937 9.96254 2.27128C11.3033 3.14431 12.1636 4.43934 12.4595 6.02714C12.5192 6.34364 12.5436 7.19293 12.5029 7.53317C12.3482 8.84403 11.781 9.99136 10.8338 10.9092C10.0385 11.6794 9.1239 12.1779 8.04914 12.4205C7.23221 12.6052 6.26058 12.6052 5.44365 12.4205C3.96721 12.0856 2.71875 11.2257 1.86111 9.95707C1.7824 9.84102 1.64127 9.59046 1.54899 9.40319C1.14731 8.60401 0.965473 7.83122 0.965473 6.94236C0.965473 6.09835 1.12017 5.39413 1.47843 4.61605C1.67384 4.18613 1.6657 3.97513 1.43772 3.80897C1.34815 3.74039 1.31559 3.73248 1.13917 3.73248C0.854197 3.73248 0.780918 3.79578 0.582792 4.21779C0.324958 4.76376 0.134974 5.3994 0.0372687 6.02714C-0.0170123 6.39639 -0.0115842 7.55691 0.0508389 7.93935C0.162115 8.62248 0.357526 9.21592 0.680498 9.85157C1.34273 11.1572 2.40935 12.1937 3.74737 12.832C4.39874 13.1432 5.00669 13.3331 5.68792 13.4386C6.12216 13.5072 7.10194 13.5204 7.56061 13.4676C9.09133 13.2856 10.4836 12.6236 11.5557 11.5633C12.1066 11.02 12.4812 10.5083 12.8123 9.85157C13.2845 8.90997 13.4718 8.15827 13.4962 7.09534C13.5125 6.48607 13.4772 6.07725 13.366 5.55502C12.9453 3.59005 11.5285 1.85719 9.62872 0.984161C9.07505 0.730957 8.3884 0.527867 7.73702 0.430278C7.30549 0.364339 6.17645 0.364339 5.74763 0.430278C5.1831 0.517317 4.53173 0.696669 4.1002 0.883935C4.01878 0.918223 3.95093 0.944598 3.95093 0.939323C3.95093 0.936685 3.9835 0.857559 4.02149 0.762608C4.15991 0.435553 4.09206 0.166524 3.83694 0.0372842C3.72837 -0.0181041 3.46783 -0.0101915 3.36741 0.0504719Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.8372 4.24411C5.65536 4.28895 5.51965 4.41555 5.4708 4.59227C5.44909 4.66612 5.44366 5.14088 5.44909 6.08775C5.45995 7.44609 5.45995 7.48038 5.51965 7.63335C5.6445 7.95777 5.85077 8.20306 6.1276 8.35604C6.41529 8.51429 6.46143 8.51957 7.62847 8.51957C8.68966 8.51957 8.69238 8.51957 8.78465 8.4589C9.03706 8.29274 9.09134 7.97623 8.90136 7.75468C8.75209 7.58324 8.76023 7.58588 7.65018 7.57005L6.64056 7.55686L6.55913 7.48038C6.513 7.43554 6.46143 7.35905 6.44786 7.30894C6.43157 7.25091 6.42072 6.68648 6.42072 5.90313C6.42072 5.04065 6.40986 4.56853 6.39086 4.51842C6.31487 4.31797 6.05975 4.194 5.8372 4.24411Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconLanguageSelection" viewBox="0 0 16 15">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.86417 4H8.89984C9.09138 3.02306 9.50445 2.10015 10.1099 1.30404C10.8337 2.25563 11.2825 3.38838 11.4067 4.57801C11.7732 4.94054 12.0003 5.44375 12.0003 6V7.55924C12.2281 6.93756 12.3743 6.28535 12.4324 5.61882H14.1689C14.0001 6.97774 13.1648 8.12988 12.0003 8.73787V9.8578C13.8863 9.10623 15.2193 7.26351 15.2193 5.10948C15.2193 2.28759 12.9317 0 10.1098 0C7.6689 0 5.62777 1.71156 5.12109 4H6.1715C6.55122 2.64935 7.60706 1.58174 8.95071 1.18548C8.40319 2.04036 8.03332 2.99778 7.86417 4ZM11.2692 1.18559C11.9251 2.20964 12.326 3.38081 12.4324 4.59987H14.1689C13.9664 2.97085 12.8062 1.63902 11.2692 1.18559Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.04832 10.5844L6.02761 7.54655H5.9687L4.94985 10.5844H7.04832Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4.5C0.895431 4.5 0 5.39543 0 6.5V13C0 14.1046 0.895431 15 2 15H9.5C10.6046 15 11.5 14.1046 11.5 13V6.5C11.5 5.39543 10.6046 4.5 9.5 4.5H2ZM2.5 13.5413H3.95818L4.58183 11.6817H7.41701L8.04181 13.5413H9.49999L6.84139 6H5.15491L2.5 13.5413Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconUnservicable" viewBox="0 0 16 16">
        <path
          id="Path_2903"
          data-name="Path 2903"
          d="M11.26,12.14l.88-.82a.413.413,0,0,0,0-.62L9.1,7.66a4.844,4.844,0,0,0,.16-.54,2.392,2.392,0,0,0,.06-.54,2.8,2.8,0,0,0-2.8-2.8,2.4,2.4,0,0,0-.68.1,3.166,3.166,0,0,0-.66.28L6.94,5.9,5.86,6.92,4.14,5.22a2.8,2.8,0,0,0-.27.66,2.725,2.725,0,0,0-.09.7,2.61,2.61,0,0,0,.8,1.93,2.658,2.658,0,0,0,1.94.79,3.025,3.025,0,0,0,.55-.05,3.541,3.541,0,0,0,.55-.15l3.02,3.04a.46.46,0,0,0,.62,0M8,16a7.741,7.741,0,0,1-3.1-.63A8.06,8.06,0,0,1,.63,11.1,7.741,7.741,0,0,1,0,8,7.789,7.789,0,0,1,.63,4.88,7.994,7.994,0,0,1,2.35,2.34,8.2,8.2,0,0,1,4.9.63,7.741,7.741,0,0,1,8,0a7.789,7.789,0,0,1,3.12.63,7.987,7.987,0,0,1,4.25,4.25A7.789,7.789,0,0,1,16,8a7.741,7.741,0,0,1-.63,3.1,8.2,8.2,0,0,1-1.71,2.55,7.994,7.994,0,0,1-2.54,1.72A7.789,7.789,0,0,1,8,16"
          fill="#bc5151"
        />
      </symbol>
      <symbol id="iconUnservicableDefault" viewBox="0 0 16 16">
        <path
          id="Path_2903"
          data-name="Path 2903"
          d="M11.26,12.14l.88-.82a.413.413,0,0,0,0-.62L9.1,7.66a4.844,4.844,0,0,0,.16-.54,2.392,2.392,0,0,0,.06-.54,2.8,2.8,0,0,0-2.8-2.8,2.4,2.4,0,0,0-.68.1,3.166,3.166,0,0,0-.66.28L6.94,5.9,5.86,6.92,4.14,5.22a2.8,2.8,0,0,0-.27.66,2.725,2.725,0,0,0-.09.7,2.61,2.61,0,0,0,.8,1.93,2.658,2.658,0,0,0,1.94.79,3.025,3.025,0,0,0,.55-.05,3.541,3.541,0,0,0,.55-.15l3.02,3.04a.46.46,0,0,0,.62,0M8,16a7.741,7.741,0,0,1-3.1-.63A8.06,8.06,0,0,1,.63,11.1,7.741,7.741,0,0,1,0,8,7.789,7.789,0,0,1,.63,4.88,7.994,7.994,0,0,1,2.35,2.34,8.2,8.2,0,0,1,4.9.63,7.741,7.741,0,0,1,8,0a7.789,7.789,0,0,1,3.12.63,7.987,7.987,0,0,1,4.25,4.25A7.789,7.789,0,0,1,16,8a7.741,7.741,0,0,1-.63,3.1,8.2,8.2,0,0,1-1.71,2.55,7.994,7.994,0,0,1-2.54,1.72A7.789,7.789,0,0,1,8,16"
          fill="#6b6a66"
        />
      </symbol>
      <symbol id="iconUnservicableStrike" viewBox="0 0 16 16">
        <g
          id="Group_2095"
          data-name="Group 2095"
          transform="translate(-675 -409)"
        >
          <g
            id="Repair_in_progress"
            data-name="Repair in progress"
            transform="translate(675 409)"
          >
            <g
              id="Group_1962"
              data-name="Group 1962"
              clip-path="url(#clip-path)"
            >
              <path
                id="Path_2903"
                data-name="Path 2903"
                d="M10.9,12.14l.852-.82a.422.422,0,0,0,0-.62L8.813,7.66a4.964,4.964,0,0,0,.155-.54,2.467,2.467,0,0,0,.058-.54A2.743,2.743,0,0,0,8.232,4.6a2.572,2.572,0,0,0-1.918-.82,2.252,2.252,0,0,0-.659.1,3.015,3.015,0,0,0-.639.28l1.7,1.74L5.675,6.92,4.009,5.22a2.857,2.857,0,0,0-.261.66,2.808,2.808,0,0,0-.087.7,2.653,2.653,0,0,0,.775,1.93,2.533,2.533,0,0,0,1.879.79,2.84,2.84,0,0,0,.533-.05A3.345,3.345,0,0,0,7.38,9.1L10.3,12.14a.436.436,0,0,0,.6,0M7.748,16a7.294,7.294,0,0,1-3-.63,7.851,7.851,0,0,1-2.47-1.72A8.135,8.135,0,0,1,.61,11.1,7.958,7.958,0,0,1,0,8,7.963,7.963,0,0,1,4.745.63a7.294,7.294,0,0,1,3-.63,7.339,7.339,0,0,1,3.022.63,7.817,7.817,0,0,1,2.46,1.71,8.1,8.1,0,0,1,1.656,2.54A8.008,8.008,0,0,1,15.5,8a7.958,7.958,0,0,1-.61,3.1,8.225,8.225,0,0,1-1.656,2.55,7.735,7.735,0,0,1-2.46,1.72A7.339,7.339,0,0,1,7.748,16"
                fill="#bbbab5"
              />
            </g>
          </g>
          <path
            id="Path_3003"
            data-name="Path 3003"
            d="M.948,15.109,15.5,1.024"
            transform="translate(675.5 409.5)"
            fill="none"
            stroke="#707070"
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
      </symbol>
      <symbol id="iconImportRound" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.04066 3.23585C5.51999 1.56291 6.3314 0.322299 7.12401 0.0497411C7.30885 -0.0160487 7.67852 -0.0160487 7.86649 0.0466083C8.66224 0.316033 9.47678 1.55664 9.95924 3.23585C10.0658 3.61179 10.2569 4.4138 10.2569 4.49212C10.2569 4.50152 9.01625 4.50779 7.49995 4.50779C5.98365 4.50779 4.74304 4.50152 4.74304 4.49212C4.74304 4.4138 4.93415 3.61179 5.04066 3.23585Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.99118 0.848617C4.32013 0.673178 4.5551 0.572926 4.97803 0.416284C5.25059 0.316033 5.33831 0.294103 5.33831 0.325431C5.33831 0.331697 5.25999 0.453878 5.166 0.597989C4.59269 1.45639 4.06951 2.85364 3.81888 4.20077L3.75935 4.50779H2.18353C1.31573 4.50779 0.607707 4.49525 0.607707 4.48272C0.607707 4.46706 0.673497 4.32295 0.758084 4.16004C1.47551 2.73459 2.5908 1.59424 3.99118 0.848617Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.66166 0.319166C9.66166 0.331697 9.73998 0.453878 9.83397 0.597989C10.4073 1.45639 10.9305 2.85364 11.1811 4.20077L11.2406 4.50779H12.8164C13.7124 4.50779 14.3923 4.49525 14.3923 4.47959C14.3923 4.41067 13.9975 3.69324 13.7845 3.37369C13.4712 2.8975 13.2644 2.64687 12.8478 2.22394C12.24 1.6099 11.5946 1.13997 10.8459 0.770296C10.3384 0.519668 9.66166 0.262774 9.66166 0.319166Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 7.51532C0 6.64753 0.0187971 6.44076 0.172307 5.78286L0.238097 5.5103H3.62157L3.60278 5.68887C3.49313 6.69765 3.49313 8.333 3.60278 9.33864L3.62157 9.52035H0.238097L0.172307 9.24466C0.0187971 8.58989 0 8.38312 0 7.51532Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.57385 5.68887C4.51432 6.23086 4.49239 6.71332 4.49239 7.51532C4.49239 8.31733 4.51432 8.79979 4.57385 9.33864L4.59578 9.52035H6.93361C7.48828 8.0167 8.85173 6.90459 10.4962 6.71178C10.4826 6.33993 10.4591 5.98898 10.426 5.68887L10.4041 5.5103H4.59578L4.57385 5.68887Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8728 9.04675C14.2203 7.77254 12.9563 6.86329 11.468 6.70621C11.4562 6.32875 11.4338 6.01829 11.3972 5.68887L11.3784 5.5103H14.7619L14.8276 5.78286C14.9812 6.44076 15 6.64753 15 7.51532C15 8.28938 14.985 8.53751 14.8728 9.04675Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.69504 10.5235C6.6763 10.6872 6.66667 10.8537 6.66667 11.0225C6.66667 12.4881 7.39308 13.784 8.50551 14.5699C8.41322 14.6581 8.32009 14.7338 8.22677 14.796C7.93228 14.9903 7.74744 15.0435 7.42789 15.0279C7.20546 15.0153 7.13967 14.9997 6.93604 14.8932C6.20295 14.5078 5.48239 13.3299 5.04066 11.7948C4.93415 11.4188 4.74304 10.6168 4.74304 10.5385C4.74304 10.5308 5.56817 10.5253 6.69504 10.5235Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.607707 10.5385C0.607707 10.5917 0.823873 11.0178 1.01184 11.3342C1.723 12.5341 2.71611 13.4896 3.96299 14.1663C4.38279 14.395 5.28192 14.7553 5.32578 14.7114C5.33518 14.7052 5.26312 14.5799 5.166 14.4358C4.59269 13.5742 4.06951 12.177 3.81888 10.8267L3.75935 10.5228H2.18353C1.31573 10.5228 0.607707 10.5291 0.607707 10.5385Z"
          className="icon-fill"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4189 9.07062C11.4189 8.87036 11.2343 8.70801 11.0066 8.70801C10.7789 8.70801 10.5943 8.87036 10.5943 9.07062V12.1003L9.39523 11.0457C9.23422 10.9041 8.97317 10.9041 8.81216 11.0457C8.65115 11.1873 8.65115 11.4169 8.81216 11.5585L10.715 13.2321C10.7924 13.3001 10.8972 13.3383 11.0066 13.3383C11.1159 13.3383 11.2208 13.3001 11.2981 13.2321L13.201 11.5585C13.362 11.4169 13.362 11.1873 13.201 11.0457C13.04 10.9041 12.7789 10.9041 12.6179 11.0457L11.4189 12.1003V9.07062Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconImportRoundStrike" viewBox="0 0 16 16">
        <g
          id="Group_2094"
          data-name="Group 2094"
          transform="translate(-641.305 -413.525)"
        >
          <g
            id="Group_2092"
            data-name="Group 2092"
            transform="translate(-26.005 -121.018)"
          >
            <g
              id="Component_168_1"
              data-name="Component 168 – 1"
              transform="translate(668 535)"
            >
              <g
                id="Group_1966"
                data-name="Group 1966"
                clip-path="url(#clip-path)"
              >
                <path
                  id="Path_2906"
                  data-name="Path 2906"
                  d="M5.382,3.442C5.893,1.661,6.758.34,7.6.051a1.547,1.547,0,0,1,.792,0c.853.287,1.716,1.608,2.231,3.4.113.4.32,1.254.32,1.337,0,.01-1.322.017-2.939.017s-2.939-.007-2.939-.017c0-.083.2-.937.32-1.337M4.268.9A7.553,7.553,0,0,1,5.32.445c.291-.106.385-.13.385-.1,0,.007-.084.137-.185.29A11.137,11.137,0,0,0,4.085,4.47L4.021,4.8H2.336c-.925,0-1.68-.014-1.68-.026a2.86,2.86,0,0,1,.16-.344A8.1,8.1,0,0,1,4.263.9M10.309.338a2.761,2.761,0,0,0,.183.3,11.1,11.1,0,0,1,1.436,3.832l.064.327h1.68c.959,0,1.68-.014,1.68-.03A8.362,8.362,0,0,0,14.7,3.592a6.867,6.867,0,0,0-1-1.224A7.824,7.824,0,0,0,11.572.82,4.821,4.821,0,0,0,10.31.34M.008,8A6.148,6.148,0,0,1,.193,6.153l.069-.291H3.869l-.021.191a21.586,21.586,0,0,0,0,3.885l.021.192H.261L.193,9.838A6.132,6.132,0,0,1,.008,8M4.884,6.053a21.885,21.885,0,0,0,0,3.885l.023.192H7.4a4.629,4.629,0,0,1,3.8-2.985c-.014-.4-.04-.77-.075-1.089L11.1,5.865H4.912Zm10.98,3.574a4.625,4.625,0,0,0-3.63-2.492c-.012-.4-.036-.732-.074-1.083l-.021-.191h3.607l.07.291a9.609,9.609,0,0,1,.048,3.475M7.146,11.2a4.942,4.942,0,0,0-.03.533,4.612,4.612,0,0,0,1.96,3.776,2.151,2.151,0,0,1-.3.24,1.225,1.225,0,0,1-.853.247.98.98,0,0,1-.525-.144,5.532,5.532,0,0,1-2.026-3.3c-.114-.4-.319-1.254-.319-1.338,0-.007.881-.014,2.08-.016m-6.489.016a5.358,5.358,0,0,0,.426.851,8.086,8.086,0,0,0,3.146,3.015,6.381,6.381,0,0,0,1.452.581,1.264,1.264,0,0,0-.17-.293,11.171,11.171,0,0,1-1.436-3.841L4,11.206H2.336c-.925,0-1.68.006-1.68.016"
                  transform="translate(0 0)"
                  fill="#666464"
                  fill-rule="evenodd"
                />
                <path
                  id="Path_2907"
                  data-name="Path 2907"
                  d="M14.58,14.69l1.331-1.311a.683.683,0,0,1,.481-.2.654.654,0,0,1,.5.2.718.718,0,0,1,0,.979L14.37,16.875a.677.677,0,0,1-.981,0l-2.522-2.518a.638.638,0,0,1-.2-.49.7.7,0,0,1,.218-.49.736.736,0,0,1,.49-.2.644.644,0,0,1,.49.2l1.313,1.311V11.123a.7.7,0,1,1,1.4,0Z"
                  transform="translate(-2.135 -2.099)"
                  fill="#666464"
                />
              </g>
            </g>
          </g>
          <path
            id="Path_3003"
            data-name="Path 3003"
            d="M.948,15.109,15.5,1.024"
            transform="translate(641.771 413.915)"
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
      </symbol>
      <symbol id="iconImportRoundDefault" viewBox="0 0 16 16">
        <path
          id="Path_2906"
          data-name="Path 2906"
          d="M5.382,3.442C5.893,1.661,6.758.34,7.6.051a1.547,1.547,0,0,1,.792,0c.853.287,1.716,1.608,2.231,3.4.113.4.32,1.254.32,1.337,0,.01-1.322.017-2.939.017s-2.939-.007-2.939-.017c0-.083.2-.937.32-1.337M4.268.9A7.553,7.553,0,0,1,5.32.445c.291-.106.385-.13.385-.1,0,.007-.084.137-.185.29A11.137,11.137,0,0,0,4.085,4.47L4.021,4.8H2.336c-.925,0-1.68-.014-1.68-.026a2.86,2.86,0,0,1,.16-.344A8.1,8.1,0,0,1,4.263.9M10.309.338a2.761,2.761,0,0,0,.183.3,11.1,11.1,0,0,1,1.436,3.832l.064.327h1.68c.959,0,1.68-.014,1.68-.03A8.362,8.362,0,0,0,14.7,3.592a6.867,6.867,0,0,0-1-1.224A7.824,7.824,0,0,0,11.572.82,4.821,4.821,0,0,0,10.31.34M.008,8A6.148,6.148,0,0,1,.193,6.153l.069-.291H3.869l-.021.191a21.586,21.586,0,0,0,0,3.885l.021.192H.261L.193,9.838A6.132,6.132,0,0,1,.008,8M4.884,6.053a21.885,21.885,0,0,0,0,3.885l.023.192H7.4a4.629,4.629,0,0,1,3.8-2.985c-.014-.4-.04-.77-.075-1.089L11.1,5.865H4.912Zm10.98,3.574a4.625,4.625,0,0,0-3.63-2.492c-.012-.4-.036-.732-.074-1.083l-.021-.191h3.607l.07.291a9.609,9.609,0,0,1,.048,3.475M7.146,11.2a4.942,4.942,0,0,0-.03.533,4.612,4.612,0,0,0,1.96,3.776,2.151,2.151,0,0,1-.3.24,1.225,1.225,0,0,1-.853.247.98.98,0,0,1-.525-.144,5.532,5.532,0,0,1-2.026-3.3c-.114-.4-.319-1.254-.319-1.338,0-.007.881-.014,2.08-.016m-6.489.016a5.358,5.358,0,0,0,.426.851,8.086,8.086,0,0,0,3.146,3.015,6.381,6.381,0,0,0,1.452.581,1.264,1.264,0,0,0-.17-.293,11.171,11.171,0,0,1-1.436-3.841L4,11.206H2.336c-.925,0-1.68.006-1.68.016"
          transform="translate(0 0)"
          fill="#6b6a66"
          fill-rule="evenodd"
        />
        <path
          id="Path_2907"
          data-name="Path 2907"
          d="M14.58,14.69l1.331-1.311a.683.683,0,0,1,.481-.2.654.654,0,0,1,.5.2.718.718,0,0,1,0,.979L14.37,16.875a.677.677,0,0,1-.981,0l-2.522-2.518a.638.638,0,0,1-.2-.49.7.7,0,0,1,.218-.49.736.736,0,0,1,.49-.2.644.644,0,0,1,.49.2l1.313,1.311V11.123a.7.7,0,1,1,1.4,0Z"
          transform="translate(-2.135 -2.099)"
          fill="#6b6a66"
        />
      </symbol>
      <symbol id="iconFrequency" viewBox="0 0 19 13">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.24088 3.03203L6.62923 9.49282C6.38018 10.1089 5.56294 10.2347 5.14012 9.72205L2.40301 6.40322H0V4.90322H2.69691C2.95865 4.90322 3.2067 5.02018 3.37324 5.22211L5.63103 7.95974L8.48334 0.903604C8.78863 0.148347 9.86908 0.181493 10.1275 0.954056L13.0494 9.68921L14.9162 5.98889C15.0652 5.69344 15.368 5.5071 15.6989 5.5071H19V7.0071H16.0826L13.7152 11.6996C13.3643 12.3952 12.3482 12.3217 12.1011 11.5829L9.24088 3.03203Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconStar" viewBox="0 0 18 17">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00281 0.529507C8.35131 -0.176502 9.35806 -0.176503 9.70656 0.529507L11.9279 5.02967L16.8957 5.75579C17.6747 5.86964 17.9851 6.82709 17.4212 7.37634L13.8272 10.8768L14.6754 15.8219C14.8085 16.598 13.9938 17.1898 13.2969 16.8233L8.85468 14.4872L4.4125 16.8233C3.71555 17.1898 2.90088 16.598 3.03399 15.8219L3.88213 10.8768L0.288188 7.37634C-0.275724 6.82709 0.0347153 5.86964 0.813637 5.75579L5.78149 5.02967L8.00281 0.529507ZM8.85468 2.19259L6.9987 5.9526C6.86044 6.23271 6.59332 6.42694 6.28423 6.47212L2.13266 7.07893L5.13596 10.0041C5.36004 10.2224 5.46232 10.537 5.40944 10.8453L4.70082 14.9769L8.41251 13.025C8.68932 12.8794 9.02005 12.8794 9.29686 13.025L13.0085 14.9769L12.2999 10.8453C12.247 10.537 12.3493 10.2224 12.5734 10.0041L15.5767 7.07893L11.4251 6.47212C11.1161 6.42694 10.8489 6.23271 10.7107 5.9526L8.85468 2.19259Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconQa" viewBox="0 0 16 20">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.72222 9.5C7.94264 9.5 6.5 10.9426 6.5 12.7222C6.5 14.5018 7.94264 15.9444 9.72222 15.9444C11.5018 15.9444 12.9444 14.5018 12.9444 12.7222C12.9444 10.9426 11.5018 9.5 9.72222 9.5ZM5 12.7222C5 10.1142 7.11421 8 9.72222 8C12.3302 8 14.4444 10.1142 14.4444 12.7222C14.4444 15.3302 12.3302 17.4444 9.72222 17.4444C7.11421 17.4444 5 15.3302 5 12.7222Z"
          className="icon-fill"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.1588 15.1589C12.3801 14.9376 12.7389 14.9376 12.9602 15.1589L15.1507 17.3493C15.372 17.5706 15.372 17.9294 15.1507 18.1507C14.9294 18.372 14.5706 18.372 14.3493 18.1507L12.1588 15.9603C11.9375 15.739 11.9375 15.3802 12.1588 15.1589Z"
          className="icon-fill"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.73654 0.73654C1.20814 0.264941 1.84776 0 2.51471 0H9.57353C9.77244 0 9.96321 0.0790176 10.1039 0.21967L15.398 5.51379C15.5386 5.65444 15.6176 5.84521 15.6176 6.04412V9.45588C15.6176 9.8701 15.2819 10.2059 14.8676 10.2059C14.4534 10.2059 14.1176 9.8701 14.1176 9.45588V6.35478L9.26287 1.5H2.51471C2.24559 1.5 1.98749 1.60691 1.7972 1.7972C1.60691 1.98749 1.5 2.24559 1.5 2.51471V16.6324C1.5 16.9015 1.60691 17.1596 1.7972 17.3499C1.98749 17.5402 2.24559 17.6471 2.51471 17.6471H6.80882C7.22304 17.6471 7.55882 17.9828 7.55882 18.3971C7.55882 18.8113 7.22304 19.1471 6.80882 19.1471H2.51471C1.84776 19.1471 1.20814 18.8821 0.73654 18.4105C0.264941 17.9389 0 17.2993 0 16.6324V2.51471C0 1.84776 0.264941 1.20814 0.73654 0.73654Z"
          className="icon-fill"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.57353 0C9.98774 0 10.3232 0.335786 10.3232 0.75V5.29412H14.8674C15.2816 5.29412 15.6176 5.6299 15.6176 6.04412C15.6176 6.45833 15.2816 6.79412 14.8674 6.79412H9.57324C9.15903 6.79412 8.82324 6.45833 8.82324 6.04412V0.75C8.82324 0.335786 9.15932 0 9.57353 0Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconUsersOutline" viewBox="0 0 18 17">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.09835 10.5984C1.80161 9.89509 2.75544 9.5 3.75 9.5H9.75C10.7446 9.5 11.6984 9.89509 12.4016 10.5984C13.1049 11.3016 13.5 12.2554 13.5 13.25V14.75C13.5 15.1642 13.1642 15.5 12.75 15.5C12.3358 15.5 12 15.1642 12 14.75V13.25C12 12.6533 11.7629 12.081 11.341 11.659C10.919 11.2371 10.3467 11 9.75 11H3.75C3.15326 11 2.58097 11.2371 2.15901 11.659C1.73705 12.081 1.5 12.6533 1.5 13.25V14.75C1.5 15.1642 1.16421 15.5 0.75 15.5C0.335786 15.5 0 15.1642 0 14.75V13.25C0 12.2554 0.395088 11.3016 1.09835 10.5984Z"
          className="icon-fill"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.75 2C5.50736 2 4.5 3.00736 4.5 4.25C4.5 5.49264 5.50736 6.5 6.75 6.5C7.99264 6.5 9 5.49264 9 4.25C9 3.00736 7.99264 2 6.75 2ZM3 4.25C3 2.17893 4.67893 0.5 6.75 0.5C8.82107 0.5 10.5 2.17893 10.5 4.25C10.5 6.32107 8.82107 8 6.75 8C4.67893 8 3 6.32107 3 4.25Z"
          className="icon-fill"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.274 10.1599C14.3776 9.75879 14.7866 9.51761 15.1877 9.62117C15.9922 9.82889 16.7049 10.2979 17.214 10.9546C17.723 11.6113 17.9996 12.4184 18.0002 13.2493V14.7499C18.0002 15.1641 17.6644 15.4999 17.2502 15.4999C16.836 15.4999 16.5002 15.1641 16.5002 14.7499V13.2501C16.4997 12.7517 16.3338 12.2675 16.0285 11.8736C15.723 11.4796 15.2954 11.1982 14.8127 11.0735C14.4116 10.97 14.1704 10.5609 14.274 10.1599Z"
          className="icon-fill"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.2736 1.16132C11.3764 0.76005 11.7849 0.518045 12.1862 0.620786C12.9928 0.827318 13.7078 1.29644 14.2184 1.9542C14.7289 2.61196 15.0061 3.42094 15.0061 4.2536C15.0061 5.08626 14.7289 5.89524 14.2184 6.553C13.7078 7.21075 12.9928 7.67988 12.1862 7.88641C11.7849 7.98915 11.3764 7.74715 11.2736 7.34588C11.1709 6.94461 11.4129 6.53603 11.8142 6.43329C12.2981 6.30937 12.7271 6.02789 13.0334 5.63324C13.3398 5.23858 13.5061 4.75319 13.5061 4.2536C13.5061 3.754 13.3398 3.26862 13.0334 2.87396C12.7271 2.47931 12.2981 2.19783 11.8142 2.07391C11.4129 1.97117 11.1709 1.56259 11.2736 1.16132Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconImportOutline" viewBox="0 0 20 20">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.0003 2.4165C5.81217 2.4165 2.41699 5.81168 2.41699 9.99984C2.41699 14.188 5.81217 17.5832 10.0003 17.5832C14.1885 17.5832 17.5837 14.188 17.5837 9.99984C17.5837 5.81168 14.1885 2.4165 10.0003 2.4165ZM0.916992 9.99984C0.916992 4.98325 4.98374 0.916504 10.0003 0.916504C15.0169 0.916504 19.0837 4.98325 19.0837 9.99984C19.0837 15.0164 15.0169 19.0832 10.0003 19.0832C4.98374 19.0832 0.916992 15.0164 0.916992 9.99984Z"
          className="icon-fill"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.916992 9.99984C0.916992 9.58562 1.25278 9.25 1.66699 9.25H18.3337C18.7479 9.25 19.0837 9.58562 19.0837 9.99984C19.0837 10.414 18.7479 10.75 18.3337 10.75H1.66699C1.25278 10.75 0.916992 10.414 0.916992 9.99984Z"
          className="icon-fill"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.41716 9.99979C7.47508 12.6165 8.38652 15.1345 10.0003 17.1759C11.6141 15.1345 12.5256 12.6165 12.5835 9.99979C12.5256 7.38305 11.6141 4.86505 10.0003 2.82366C8.38652 4.86505 7.47508 7.38305 7.41716 9.99979ZM10.0003 1.66646L9.44657 1.16064C7.23955 3.57684 5.98531 6.71244 5.91715 9.98417C5.91694 9.99459 5.91694 10.005 5.91715 10.0154C5.98531 13.2871 7.23955 16.4227 9.44657 18.8389C9.58866 18.9945 9.78963 19.0832 10.0003 19.0832C10.211 19.0832 10.412 18.9945 10.5541 18.8389C12.7611 16.4227 14.0153 13.2871 14.0835 10.0154C14.0837 10.005 14.0837 9.99459 14.0835 9.98417C14.0153 6.71244 12.7611 3.57684 10.5541 1.16064L10.0003 1.66646Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconCheckRoundFill" viewBox="0 0 13 13">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13ZM9.87935 4.56952C10.0697 4.37914 10.0697 4.07047 9.87935 3.88009C9.68897 3.68971 9.3803 3.68971 9.18992 3.88009L5.3638 7.70621L3.81268 6.15509C3.6223 5.96471 3.31363 5.96471 3.12325 6.15509C2.93287 6.34547 2.93287 6.65414 3.12325 6.84452L5.01909 8.74035C5.11051 8.83178 5.23451 8.88314 5.3638 8.88314C5.49309 8.88314 5.61709 8.83178 5.70852 8.74035L9.87935 4.56952Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconEditRoundFill" viewBox="0 0 13 13">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13ZM7.59375 4.09375L8.6875 3L10 4.3125L8.90625 5.40625L7.59375 4.09375ZM3.4375 8.25L7.15625 4.53125L8.46875 5.84375L4.75 9.5625L3 10L3.4375 8.25Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconClearFilter" viewBox="0 0 21 24">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.0623 12.4018L19.8913 6.35704C20.0765 6.1332 20.1158 5.82251 19.9921 5.55962C19.8684 5.29673 19.604 5.12892 19.3135 5.12892H8.49233L9.86488 6.62892H17.7195L14.0399 11.2845L15.0623 12.4018Z"
          className="icon-fill"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.0635 15.7023L11.6012 14.1042C11.5764 14.1794 11.5635 14.2586 11.5635 14.3389V21.6654L9.06349 20.4154L9.06349 14.3389C9.06349 14.1644 9.0026 13.9953 8.89133 13.8608L2.9075 6.62892H4.76112L3.38858 5.12892H1.31349C1.02295 5.12892 0.758544 5.29673 0.634851 5.55962C0.511157 5.82251 0.550427 6.1332 0.735643 6.35704L7.56348 14.609L7.56349 20.8789C7.56349 21.163 7.72399 21.4227 7.97808 21.5497L11.9781 23.5497C12.2106 23.666 12.4867 23.6536 12.7078 23.5169C12.9289 23.3803 13.0635 23.1389 13.0635 22.8789V15.7023Z"
          className="icon-fill"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2.93979 1.08749C3.24474 0.807175 3.7192 0.82714 3.99952 1.13209L20.5105 19.0936C20.7908 19.3985 20.7708 19.873 20.4659 20.1533C20.1609 20.4336 19.6865 20.4137 19.4061 20.1087L2.8952 2.14721C2.61488 1.84227 2.63484 1.36781 2.93979 1.08749Z"
          className="icon-fill"
        />
      </symbol>
      <symbol id="iconLogout" viewBox="0 0 36 36">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          className="icon-fill"
          d="M16.5 33C12.0914 33 7.95352 31.2855 4.83398 28.166C1.71445 25.0465 0 20.9086 0 16.5C0 12.0914 1.71445 7.95352 4.83398 4.83398C5.6332 4.03477 6.94805 4.03477 7.74727 4.83398C8.54648 5.6332 8.54648 6.94805 7.74727 7.74727C5.41406 10.0805 4.125 13.2 4.125 16.5C4.125 19.8 5.41406 22.9195 7.74727 25.2527C10.0805 27.5859 13.2 28.875 16.5 28.875C19.8 28.875 22.9195 27.5859 25.2527 25.2527C27.5859 22.9195 28.875 19.8 28.875 16.5C28.875 13.2 27.5859 10.0805 25.2527 7.74727C24.4535 6.94805 24.4535 5.6332 25.2527 4.83398C26.052 4.03477 27.3668 4.03477 28.166 4.83398C31.2855 7.95352 33 12.0914 33 16.5C33 20.9086 31.2855 25.0465 28.166 28.166C25.0465 31.2855 20.9086 33 16.5 33ZM16.5 18.5625C17.6344 18.5625 18.5625 17.6344 18.5625 16.5V2.0625C18.5625 0.928125 17.6344 0 16.5 0C15.3656 0 14.4375 0.928125 14.4375 2.0625V16.5C14.4375 17.6344 15.3656 18.5625 16.5 18.5625Z"
        ></path>
      </symbol>
      <symbol id="iconStored" viewBox="0 0 22 22">
        <g id="Group_194" data-name="Group 194" transform="translate(0 -0.5)">
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="11"
            cy="11"
            r="11"
            transform="translate(0 0.5)"
            fill="#517dbb"
          />
          <g
            id="Rectangle_2255"
            data-name="Rectangle 2255"
            transform="translate(6 6.5)"
            fill="none"
            stroke="#fff"
            stroke-width="2"
          >
            <rect width="10" height="10" stroke="none" />
            <rect x="1" y="1" width="8" height="8" fill="none" />
          </g>
        </g>
      </symbol>
      <symbol id="iconExpended" viewBox="0 0 22 22">
        <g
          id="Group_2112"
          data-name="Group 2112"
          transform="translate(-1389.117 -686.261)"
        >
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="11"
            cy="11"
            r="11"
            transform="translate(1389.117 686.261)"
            fill="#888"
          />
          <path
            id="Path_2571"
            data-name="Path 2571"
            d="M1395.116,712.869V705.5h7v7.369"
            transform="translate(2798.733 1405.75) rotate(-180)"
            fill="none"
            stroke="#fff"
            stroke-width="2"
          />
        </g>
      </symbol>
      <symbol id="iconMarkedtoDestroy" viewBox="0 0 22 22">
        <g
          id="Group_2111"
          data-name="Group 2111"
          transform="translate(-1106.117 -654.261)"
        >
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="11"
            cy="11"
            r="11"
            transform="translate(1106.117 654.261)"
            fill="#c2b653"
          />
          <path
            id="Path_2566"
            data-name="Path 2566"
            d="M0,0,3.523,3.523,0,7.046"
            transform="translate(1113.802 670.861) rotate(-90)"
            fill="none"
            stroke="#fff"
            stroke-width="2"
          />
          <path
            id="Path_2569"
            data-name="Path 2569"
            d="M1036.531,468.215l6.281-5.906"
            transform="translate(77.487 197.337)"
            fill="none"
            stroke="#fff"
            stroke-width="2"
          />
          <path
            id="Path_2570"
            data-name="Path 2570"
            d="M1042.813,468.215l-6.281-5.906"
            transform="translate(77.487 197.337)"
            fill="none"
            stroke="#fff"
            stroke-width="2"
          />
        </g>
      </symbol>
      <symbol id="iconIssued" viewBox="0 0 22 22">
        <g id="Group_194" data-name="Group 194" transform="translate(0 0)">
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="11"
            cy="11"
            r="11"
            transform="translate(0 0)"
            fill="#86b373"
          />
          <path
            id="Path_1"
            data-name="Path 1"
            d="M1035.813,465.146l2.917,3.174,6.254-6.011"
            transform="translate(-1029.169 -454.701)"
            fill="none"
            stroke="#fff"
            stroke-width="2"
          />
        </g>
      </symbol>
      <symbol id="iconDestroyed" viewBox="0 0 22 22">
        <g id="Group_194" data-name="Group 194" transform="translate(0 0)">
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="11"
            cy="11"
            r="11"
            transform="translate(0 0)"
            fill="#888"
          />
          <g
            id="Group_1406"
            data-name="Group 1406"
            transform="translate(7 6.91)"
          >
            <path
              id="Path_1"
              data-name="Path 1"
              d="M1038.8,470.309l8-8"
              transform="translate(-1038.796 -462.309)"
              fill="none"
              stroke="#fff"
              stroke-width="2"
            />
            <path
              id="Path_2562"
              data-name="Path 2562"
              d="M1046.8,470.308l-8-8"
              transform="translate(-1038.796 -462.309)"
              fill="none"
              stroke="#fff"
              stroke-width="2"
            />
          </g>
        </g>
      </symbol>
      <symbol id="iconLost" viewBox="0 0 22 22">
        <g id="Group_194" data-name="Group 194" transform="translate(0 -0.509)">
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="11"
            cy="11"
            r="11"
            transform="translate(0 0.509)"
            fill="#b64f49"
          />
          <path
            id="Path_2565"
            data-name="Path 2565"
            d="M3.877-21.457v-.187a5.752,5.752,0,0,1,.173-1.533,2.287,2.287,0,0,1,.492-.923,3.786,3.786,0,0,1,.78-.637,5.182,5.182,0,0,0,.61-.456,1.956,1.956,0,0,0,.429-.525,1.312,1.312,0,0,0,.159-.645,1.214,1.214,0,0,0-.181-.665,1.211,1.211,0,0,0-.486-.439,1.473,1.473,0,0,0-.673-.154,1.512,1.512,0,0,0-.676.157A1.317,1.317,0,0,0,3.981-27a1.43,1.43,0,0,0-.22.755H1.52a3.249,3.249,0,0,1,.527-1.816,3.046,3.046,0,0,1,1.324-1.071,4.556,4.556,0,0,1,1.818-.354,4.876,4.876,0,0,1,1.934.36,3.016,3.016,0,0,1,1.318,1.041,2.787,2.787,0,0,1,.478,1.643,2.889,2.889,0,0,1-.212,1.14,2.782,2.782,0,0,1-.591.879,4.494,4.494,0,0,1-.9.689,3.554,3.554,0,0,0-.711.538,1.78,1.78,0,0,0-.412.648,2.74,2.74,0,0,0-.14.906v.187Zm1.088,3.516a1.276,1.276,0,0,1-.937-.387,1.251,1.251,0,0,1-.382-.931,1.235,1.235,0,0,1,.382-.923,1.281,1.281,0,0,1,.937-.385,1.276,1.276,0,0,1,.917.385,1.261,1.261,0,0,1,.4.923,1.278,1.278,0,0,1-.19.662,1.412,1.412,0,0,1-.481.478A1.234,1.234,0,0,1,4.964-17.941Z"
            transform="translate(5.48 34.998)"
            fill="#fff"
          />
        </g>
      </symbol>
      <symbol id="iconSold" viewBox="0 0 22 22">
        <g
          id="Group_1427"
          data-name="Group 1427"
          transform="translate(-413 -1942.991)"
        >
          <g
            id="Group_516"
            data-name="Group 516"
            transform="translate(413 1943.482)"
          >
            <ellipse
              id="Ellipse_4"
              data-name="Ellipse 4"
              cx="11"
              cy="11"
              rx="11"
              ry="11"
              transform="translate(0 -0.49)"
              fill="#b64f49"
            />
            <path
              id="Path_2563"
              data-name="Path 2563"
              d="M4.5-2.5V-15.545h.836V-2.5Zm2.41-8.87a1.393,1.393,0,0,0-.6-1.039,2.322,2.322,0,0,0-1.368-.372,2.6,2.6,0,0,0-1.014.178,1.5,1.5,0,0,0-.647.484,1.177,1.177,0,0,0-.229.7,1.042,1.042,0,0,0,.15.566,1.3,1.3,0,0,0,.41.405,2.824,2.824,0,0,0,.576.278,6.193,6.193,0,0,0,.637.189l.978.245a6.816,6.816,0,0,1,1.139.372,4.068,4.068,0,0,1,.983.591,2.637,2.637,0,0,1,.69.861,2.59,2.59,0,0,1,.255,1.182A2.817,2.817,0,0,1,8.4-5.124,3.076,3.076,0,0,1,7.052-4.038a5.281,5.281,0,0,1-2.137.39A5.411,5.411,0,0,1,2.8-4.026a3.131,3.131,0,0,1-1.4-1.1A3.248,3.248,0,0,1,.864-6.889h1.86a1.581,1.581,0,0,0,.336.907,1.778,1.778,0,0,0,.772.54A3.026,3.026,0,0,0,4.9-5.264,2.909,2.909,0,0,0,5.982-5.45a1.724,1.724,0,0,0,.731-.52,1.245,1.245,0,0,0,.27-.782,1.007,1.007,0,0,0-.239-.675,1.8,1.8,0,0,0-.655-.448A6.639,6.639,0,0,0,5.108-8.2L3.921-8.5A4.741,4.741,0,0,1,1.885-9.51a2.3,2.3,0,0,1-.746-1.8,2.681,2.681,0,0,1,.5-1.615A3.3,3.3,0,0,1,3.009-14a4.785,4.785,0,0,1,1.962-.385A4.63,4.63,0,0,1,6.919-14a3.2,3.2,0,0,1,1.317,1.065,2.73,2.73,0,0,1,.494,1.562Z"
              transform="translate(6.136 19.533)"
              fill="#fff"
            />
            <rect
              id="Rectangle_2353"
              data-name="Rectangle 2353"
              width="2"
              height="14"
              transform="translate(10 3.51)"
              fill="#fff"
            />
          </g>
        </g>
      </symbol>
      <symbol id="iconIntransit" viewBox="0 0 22 22">
        <g id="Group_194" data-name="Group 194" transform="translate(0 -0.008)">
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="11"
            cy="11"
            r="11"
            transform="translate(0 0.008)"
            fill="#c2b653"
          />
          <path
            id="Path_2566"
            data-name="Path 2566"
            d="M2969-4672.333l4.417,4.417L2969-4663.5"
            transform="translate(-2957 4679.429)"
            fill="none"
            stroke="#fff"
            stroke-width="2"
          />
          <circle
            id="Ellipse_140"
            data-name="Ellipse 140"
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="translate(8.505 10.013)"
            fill="#fff"
          />
          <circle
            id="Ellipse_141"
            data-name="Ellipse 141"
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="translate(3.505 10.013)"
            fill="#fff"
          />
        </g>
      </symbol>
      <symbol id="iconDraft" viewBox="0 0 22 22">
        <circle
          id="Ellipse_2"
          data-name="Ellipse 2"
          cx="11"
          cy="11"
          r="11"
          fill="#c2b653"
        />
        <line
          id="Line_186"
          data-name="Line 186"
          x2="10"
          transform="translate(6.5 8.758)"
          fill="none"
          stroke="#fff"
          stroke-width="2"
        />
        <line
          id="Line_187"
          data-name="Line 187"
          x2="5"
          transform="translate(6.5 13.758)"
          fill="none"
          stroke="#fff"
          stroke-width="2"
        />
      </symbol>
      <symbol id="iconReclaimedbyClan" viewBox="0 0 22 22">
        <g
          id="Group_1515"
          data-name="Group 1515"
          transform="translate(-652 -641)"
        >
          <g
            id="Group_1404"
            data-name="Group 1404"
            transform="translate(239 -1302.481)"
          >
            <g
              id="Group_516"
              data-name="Group 516"
              transform="translate(413 1943.482)"
            >
              <ellipse
                id="Ellipse_4"
                data-name="Ellipse 4"
                cx="11"
                cy="11"
                rx="11"
                ry="11"
                transform="translate(0)"
                fill="#517dbb"
              />
            </g>
          </g>
          <g
            id="Group_1431"
            data-name="Group 1431"
            transform="translate(0.234 1.708)"
          >
            <path
              id="Path_2567"
              data-name="Path 2567"
              d="M2972.372-4672.333l-3.372,3.372,3.372,3.372"
              transform="translate(-2310.024 5317.285)"
              fill="none"
              stroke="#fff"
              stroke-width="2"
            />
            <path
              id="Path_2568"
              data-name="Path 2568"
              d="M2967.341-4938.916h6.845v6.208h-7.29"
              transform="translate(-2308 5587.239)"
              fill="none"
              stroke="#fff"
              stroke-width="2"
            />
          </g>
        </g>
      </symbol>
      <symbol id="iconUnknown" viewBox="0 0 22 22">
        <g
          id="Group_2112"
          data-name="Group 2112"
          transform="translate(0 -0.509)"
        >
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="11"
            cy="11"
            r="11"
            transform="translate(0 0.509)"
            fill="#888"
          />
          <path
            id="Path_2565"
            data-name="Path 2565"
            d="M3.877-21.457v-.187a5.752,5.752,0,0,1,.173-1.533,2.287,2.287,0,0,1,.492-.923,3.786,3.786,0,0,1,.78-.637,5.182,5.182,0,0,0,.61-.456,1.956,1.956,0,0,0,.429-.525,1.312,1.312,0,0,0,.159-.645,1.214,1.214,0,0,0-.181-.665,1.211,1.211,0,0,0-.486-.439,1.473,1.473,0,0,0-.673-.154,1.512,1.512,0,0,0-.676.157A1.317,1.317,0,0,0,3.981-27a1.43,1.43,0,0,0-.22.755H1.52a3.249,3.249,0,0,1,.527-1.816,3.046,3.046,0,0,1,1.324-1.071,4.556,4.556,0,0,1,1.818-.354,4.876,4.876,0,0,1,1.934.36,3.016,3.016,0,0,1,1.318,1.041,2.787,2.787,0,0,1,.478,1.643,2.889,2.889,0,0,1-.212,1.14,2.782,2.782,0,0,1-.591.879,4.494,4.494,0,0,1-.9.689,3.554,3.554,0,0,0-.711.538,1.78,1.78,0,0,0-.412.648,2.74,2.74,0,0,0-.14.906v.187Zm1.088,3.516a1.276,1.276,0,0,1-.937-.387,1.251,1.251,0,0,1-.382-.931,1.235,1.235,0,0,1,.382-.923,1.281,1.281,0,0,1,.937-.385,1.276,1.276,0,0,1,.917.385,1.261,1.261,0,0,1,.4.923,1.278,1.278,0,0,1-.19.662,1.412,1.412,0,0,1-.481.478A1.234,1.234,0,0,1,4.964-17.941Z"
            transform="translate(5.48 34.998)"
            fill="#fff"
          />
        </g>
      </symbol>
      <symbol id="iconDeceased" viewBox="0 0 22 22">
        <g id="Group_194" data-name="Group 194" transform="translate(0 0)">
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="11"
            cy="11"
            r="11"
            transform="translate(0 0)"
            fill="#888"
          />
          <g
            id="Group_1406"
            data-name="Group 1406"
            transform="translate(7 6.91)"
          >
            <path
              id="Path_1"
              data-name="Path 1"
              d="M1038.8,470.309l8-8"
              transform="translate(-1038.796 -462.309)"
              fill="none"
              stroke="#fff"
              stroke-width="2"
            />
            <path
              id="Path_2562"
              data-name="Path 2562"
              d="M1046.8,470.308l-8-8"
              transform="translate(-1038.796 -462.309)"
              fill="none"
              stroke="#fff"
              stroke-width="2"
            />
          </g>
        </g>
      </symbol>
      <symbol id="iconDefected" viewBox="0 0 22 22">
        <g id="Group_194" data-name="Group 194" transform="translate(0 0)">
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="11"
            cy="11"
            r="11"
            transform="translate(0 0)"
            fill="#b64f49"
          />
          <g
            id="Group_1406"
            data-name="Group 1406"
            transform="translate(7 6.91)"
          >
            <path
              id="Path_1"
              data-name="Path 1"
              d="M1038.8,470.309l8-8"
              transform="translate(-1038.796 -462.309)"
              fill="none"
              stroke="#fff"
              stroke-width="2"
            />
            <path
              id="Path_2562"
              data-name="Path 2562"
              d="M1046.8,470.308l-8-8"
              transform="translate(-1038.796 -462.309)"
              fill="none"
              stroke="#fff"
              stroke-width="2"
            />
          </g>
        </g>
      </symbol>
      <symbol id="iconActive" viewBox="0 0 22 22">
        <g id="Group_194" data-name="Group 194" transform="translate(0 0)">
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="11"
            cy="11"
            r="11"
            transform="translate(0 0)"
            fill="#86b373"
          />
          <path
            id="Path_1"
            data-name="Path 1"
            d="M1035.813,465.146l2.917,3.174,6.254-6.011"
            transform="translate(-1029.169 -454.701)"
            fill="none"
            stroke="#fff"
            stroke-width="2"
          />
        </g>
      </symbol>
      <symbol id="iconInactive" viewBox="0 0 22 22">
        <g
          id="Group_1404"
          data-name="Group 1404"
          transform="translate(-413 -1943.482)"
        >
          <g
            id="Group_516"
            data-name="Group 516"
            transform="translate(413 1943.482)"
          >
            <ellipse
              id="Ellipse_4"
              data-name="Ellipse 4"
              cx="11"
              cy="11"
              rx="11"
              ry="11"
              transform="translate(0)"
              fill="#888"
            />
            <line
              id="Line_172"
              data-name="Line 172"
              x2="10"
              transform="translate(6.239 11.261)"
              fill="none"
              stroke="#fff"
              stroke-width="2"
            />
          </g>
        </g>
      </symbol>
    </defs>
  </svg>
);

export default index;
